import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { Link } from "react-router-dom";
import { LABELGENAPI } from '../../API';
import _ from 'lodash';
// our components
import TrackingDrawer from '../General/TrackingDrawer'
import OrderStatus from '../General/OrderStatus'
import MultipleTracking from '../General/MultipleTracking'
import Filters from './Filters'
import Search from './Search'
import DynamicColumns from '../General/DynamicColumns'
import NorowsData from '../General/NorowsData'
import Notification from '../General/Notification'
import Date from '../General/Date'
import Printer from '../General/Printer'
import {
    fetchOrderDetail
} from '../OrderDetail/orderdetailsSlice';
import CircularProgress from '@mui/material/CircularProgress';
// mui components
import {
    Stack,
    Typography,
    FormControl,
    Pagination,
    IconButton,
    Tooltip,
    Modal,
    Box,
    Button,
    List,
    ListItem,
    ListItemText,
    ListItemButton,
    ListItemIcon,
    Popover,
    Card,
    CardHeader,
    CardContent,
    Divider,
    TextField,
    Select,
    MenuItem,
    InputLabel,
    Grid,
    Collapse,
    Alert
} from "@mui/material";
import LoadingButton from '@mui/lab/LoadingButton';
import MuiPagination from '@mui/material/Pagination';
import LinearProgress from '@mui/material/LinearProgress';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import ViewColumnSharpIcon from '@mui/icons-material/ViewColumnSharp';
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import SearchIcon from '@mui/icons-material/Search';
import SettingsIcon from '@mui/icons-material/Settings';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import PrintIcon from '@mui/icons-material/Print';
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import MoreHorizRoundedIcon from '@mui/icons-material/MoreHorizRounded';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import TagOutlinedIcon from '@mui/icons-material/TagOutlined';
import Chip from '@mui/material/Chip';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import KeyboardReturnOutlinedIcon from '@mui/icons-material/KeyboardReturnOutlined';
import SyncIcon from '@mui/icons-material/Sync';
import AllInboxIcon from '@mui/icons-material/AllInbox';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import FormHelperText from '@mui/material/FormHelperText';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import LanguageIcon from '@mui/icons-material/Language';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import Radio from '@mui/material/Radio';
import InfoIcon from '@mui/icons-material/Info';
// import {
//     DataGrid,
//     GridToolbarContainer,
//     GridFooterContainer
// } from '@mui/x-data-grid';
import {
    DataGridPro,
    GridToolbarContainer,
    GridFooterContainer
} from '@mui/x-data-grid-pro';
import { DataGrid } from '@mui/x-data-grid';

//actions
import {
    fetchOrders,
    fetchOrderColumns,
    saveOrdersColumns,
    doPostTrackingNumberVoid,
    dopostTrackingNumberCloseManifest,
    printBulkLabels,
    dopostDataBulkShipment,
    resetOrderNotifications,
    fetchDistinctCarriers,
    fetchPlatformTags,
    fetchLineItemsWeight,
    updateAssignTag,
    fetchBulkSelectedOrders,
    syncOrderDatas,
    postBulkOrderValidation,
    fetchOrdersUI,
    storeDatagridData,
    updateBulkDimension,
    postdeleteOrdersData,
    fetchOrderShipments,
    fetchOrderShipmentDetails,
    fetchBulkOrderShipmentDetails,
    fetchOrderShipmentLabel,
    clearOrderShipmentDetails,
    clearOrderShipmentLabel
} from './ordersSlice';
import { fetchProfile } from '../Settings/Profile/profileSlice';
import { resetGenerateLabel } from '../Shipments/NewShipment/createShipmentSlice';
import { fetchTrackingDetail } from '../Reports/Deliveries/trackingEventsSlice';
import OrderDrawer from '../General/OrderDrawer'
import ShipmentRate from '../General/ShipmentRate'
import NewOrderCreateDrawer from '../General/NewOrder/NewOrderCreateDrawer'
import LineItemsDrawer from '../General/LineItemsDrawer'
import PageSearch from '../General/PageSearch'
import CarrierTracking from '../General/CarrierTracking'
import { fetchTagData } from '../Settings/TagSettings/tagSettingsSlice';
import { fetchCountry, fetchState,fetchMultiStates } from '../General/countryStateCitySlice';
import { fetchBulkOrderReference, fetchBulkOrderDetail,bulkReferenceCooUpdateData, resetBulkOrderNotifications } from '../BulkOrder/bulkOrderSlice';


const OrdersPage = () => {

    const dispatch = useDispatch();
    const orders = useSelector(state => state.orders);
    const country_code = useSelector(state => state.countrystate.country);
    const filteredCountryData = country_code.data.filter(({ code }) => code );
    const cooUpdate = useSelector(state => state.bulkorder && state.bulkorder.cooReferenceUpdate);
    const bulkSelectedOrdersData = useSelector(state => state.orders && state.orders.bulkSelectedOrdersData);
    const bulkvalidationOrdersData = useSelector(state => state.orders && state.orders.bulkOrderValidation);
    const orderUIUpdate = useSelector(state => state.orders && state.orders.orderUIUpdate);
    const addresssender = useSelector(state => state.addresssender);
    const addressbilling = useSelector(state => state.addressbilling);
    const box = useSelector(state => state.box)
    const tags = useSelector(state => state.tags)
    const profile = useSelector(state => state.profile.profile);
    const newcreateshipment = useSelector(state => state.createshipment);
    const [meta, setMeta] = useState(orders.ordersData.meta);
    const [showFilter, setShowFilter] = useState(false);
    const [showSearch, setShowSearch] = useState(false);
    const [showDynamicColumn, setShowDynamicColumn] = useState(false);
    const [columnCheckedObject, setColumnCheckedObject] = useState({});
    const [anchorEl, setAnchorEl] = useState(null);
    const [actionAnchorEl, setActionAnchorEl] = useState(null);
    const [openBoxModal, setOpenBoxModal] = useState(false)
    const [openSenderAddressModal, setOpenSenderAddressModal] = useState(false)
    const [openBillingAddressModal, setOpenBillingAddressModal] = useState(false)
    const actionOpen = Boolean(actionAnchorEl);
    const actionId = actionOpen ? 'simple-popover' : undefined;
    const [viewActionAnchorEl, setViewActionAnchorEl] = useState(null);
    const viewActionOpen = Boolean(viewActionAnchorEl);
    const viewActionId = viewActionOpen ? 'view-action-simple-popover' : undefined;
    
    const [viewMoreActionAnchorEl, setViewMoreActionAnchorEl] = useState(null);
    const viewMoreActionOpen = Boolean(viewMoreActionAnchorEl);
    const viewMoreActionId = viewMoreActionOpen ? 'view-more-action-simple-popover' : undefined;
    const [currentViewItem, setCurrentViewItem] = useState("")
    const [modalVisible, setModalVisible] = useState(false);
    const [tagModalVisible, setTagModalVisible] = useState(false);
    const [bulkDimensionModalVisible, setBulkDimensionModalVisible] = useState(false);
    const [deleteOrdersModalVisible, setDeleteOrdersModalVisible] = useState(false);
    const [modalDetails, setModalDetails] = useState("default")
    const [checkedIds, setCheckedIds] = useState([]);
    const [checkedItems, setCheckedItems] = useState([]);
    const [trackingDrawerVisible, setTrackingDrawerVisible] = useState(false);
    const [trackingMessage, setTrackingMessage] = useState(null);
    const [orderDrawerVisible, setOrderDrawerVisible] = useState(false);
    const [newOrderCreateDrawerVisible, setNewOrderCreateDrawerVisible] = useState(false);
    const [newOrderFormData, setNewOrderFormData] = useState("");
    const [isDuplicateOrder, setIsDuplicateOrder] = useState(false);
    const [lineItemsDrawerVisible, setLineItemsDrawerVisible] = useState(false);
    const [lineItemsData, setLineItemsData] = useState("");
    const [duplicateActionAnchorEl, setDuplicateActionAnchorEl] = useState(null);
    const duplicateActionOpen = Boolean(duplicateActionAnchorEl);
    const duplicateActionId = duplicateActionOpen ? 'view-action-simple-popover' : undefined;
    const [returnAnchorEl, setReturnActionAnchorEl] = useState(null);
    const returnActionOpen = Boolean(returnAnchorEl);
    const returnActionId = returnActionOpen ? 'view-action-simple-popover' : undefined;
    const [choosenTrackingNumber, setChoosenTrackingNumber] = useState(0);
    const [isShipmentCreationFlow, setIsShipmentCreationFlow] = useState(false)
    const [pageNumber, setPageNumber] = useState("")
    const [orderRow, setOrderRow] = useState(null)
    const [orderId, setOrderId] = useState("")
    const [printUrl, setPrintUrl] = useState("")
    const [isPrinted, setIsPrinted] = useState(true)
    const [isMultiPiece, setIsMultiPiece] = useState(false)
    const [isReturnOrder, setIsReturnOrder] = useState(false);
    const [urlParam, seturlParam] = useState("")
    const [assignTagValue, setAssignTagValue] = useState("")
    const [assignTagIds, setAssignTagIds] = useState([])
    const [bulkDimensionIds, setBulkDimensionIds] = useState([])
    const [deleteOrderIds, setDeleteOrderIds] = useState([])
    const [notDeleteOrders, setNotDeletedOrders] = useState([])
    const [customboxDimensions, setcustomboxDimensions] = useState({})
    const [totalSelectedItems, setTotalSelectedItems] = useState("")
    const [totalOrders, setTotalOrders] = useState("")
    const [selectItemTextVisible, setSelectItemTextVisible] = useState(false)
    const [selectItemView, setSelectItemView] = useState(false)
    const [viewMoreActionsRow, setViewMoreActionsRow] = useState([])
    const [boxValues, setBoxValues] = useState([])
    const [invalidDocIds, setInvalidDocIds] = useState([])
    const [notes, setNotes] = useState("")
    const [datagridSave, setDatagridSave] = useState(true)
    const [ordersDataGridConfig, setOrdersDataGridConfig] = useState({})
    const [boxData, setBoxData] = useState([])
    const [cooModalVisible, setCooModalVisible] = useState(false);
    const [bulkCooOrderIds, setBulkCooOrderIds] = useState([]);
    const [autoLabelOpen, setAutoLabelOpen] = useState(true);
    const [onPageSearch, setOnPageSearch] = useState(false);

    const [breakdownAnchorEl, setBreakdownAnchorEl] = useState(null);
    const [selectedBreakdown, setSelectedBreakdown] = useState(null);
    // 1. Initialize local states for the unfulfilled sync trigger
    const [unfulfilledSyncLoading, setUnfulfilledSyncLoading] = useState(false);
    const [unfulfilledSyncAlert, setUnfulfilledSyncAlert] = useState({ show: false, type: 'info', message: '' });

    // 2. Auto-close timer effect (closes the alert automatically after 5 seconds)
    useEffect(() => {
        let timer;
        if (unfulfilledSyncAlert.show) {
            timer = setTimeout(() => {
                setUnfulfilledSyncAlert(prev => ({ ...prev, show: false }));
            }, 5000); // 5000ms = 5 seconds
        }
        return () => clearTimeout(timer);
    }, [unfulfilledSyncAlert.show]);

    // 3. API Handler for Unfulfilled Orders Sync
    const handleUnfulfilledOrdersSync = async () => {
        setUnfulfilledSyncLoading(true);
        setUnfulfilledSyncAlert({ show: false, type: 'info', message: '' });

        try {
            const baseUrl = process.env.REACT_APP_INTEGRATIONS_URL || 'http://localhost:7000';
            const userId = profile?.id;

            const payload = {
                userid: userId
            };

            const response = await axios.post(`${baseUrl}/unfulfilled-orders-sync`, payload, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            if (response.status === 200 || response.data?.status === 'success') {
                setUnfulfilledSyncAlert({
                    show: true,
                    type: 'success',
                    message: response.data?.message || 'Unfulfilled orders synced successfully!'
                });
            } else {
                setUnfulfilledSyncAlert({
                    show: true,
                    type: 'error',
                    message: response.data?.message || 'Failed to sync unfulfilled orders.'
                });
            }
        } catch (error) {
            console.error("Unfulfilled Orders Sync Error:", error);
            setUnfulfilledSyncAlert({
                show: true,
                type: 'error',
                message: error.response?.data?.message || 'An error occurred while syncing unfulfilled orders.'
            });
        } finally {
            setUnfulfilledSyncLoading(false);
        }
    };
    const [isLoadingDuties, setIsLoadingDuties] = useState(false);
    

    const handleDutiesClick = async (event, rowData) => {
        setBreakdownAnchorEl(event.currentTarget);
        setIsLoadingDuties(true);
        setSelectedBreakdown(null);

        try {
            // Find the first tracking number from your line items
            const trackingNumber = rowData?.line_items?.find(item => item.shipment?.master_tracking_number)?.shipment?.master_tracking_number;
            const userId = rowData?.userid;

            if (!trackingNumber) {
                setSelectedBreakdown({ error: "No tracking number found for this order." });
                return;
            }

            // Call your backend endpoint (e.g., Axios or your global fetch client)
            // Adjust the URL/method to match your actual route definitions
            const response = await LABELGENAPI.get(`/orders/get-duties-info`, {
                params: { 
                    tracking_number: trackingNumber, 
                    userid: userId 
                }
            });

            // Safe extraction layer mimicking your controller variables
            const breakdownData = response.data?.shipment_rates?.breakdown?.duty_breakdown 
                            || response.data?.rate?.breakdown?.duty_breakdown;

            setSelectedBreakdown(breakdownData || { message: "No active duty breakdowns found." });
        } catch (error) {
            console.error("Failed fetching duty breakdown:", error);
            setSelectedBreakdown({ error: "Failed to load breakdown details." });
        } finally {
            setIsLoadingDuties(false);
        }
    };

    const renderDutyTooltip = (dutyBreakdown) => {
        if (!dutyBreakdown || typeof dutyBreakdown !== 'object') return null;

        const elements = [];
        const actualBreakdown = Array.isArray(dutyBreakdown) ? dutyBreakdown[0] : dutyBreakdown;

        Object.entries(actualBreakdown).forEach(([key, val]) => {
            if (val === undefined || val === null || val === "") return;

            // Strip digit suffixes like "_3"
            const cleanKey = key.replace(/_\d+$/, ''); 
            
            let formattedKey = cleanKey
                .split('_')
                .map(word => word.charAt(0).toUpperCase() + word.toLowerCase().slice(1))
                .join(' ');

            // Map Zonos Markup directly to SC Fee
            if (formattedKey === "Zonos Markup") {
                formattedKey = "SC Fee";
            }

            if (typeof val === 'object' && !Array.isArray(val)) {
                const resolvedValue = val.value !== undefined ? val.value : (val.amount !== undefined ? val.amount : val.price);
                if (resolvedValue !== undefined && resolvedValue !== null && resolvedValue !== "") {
                    const currencyStr = val.currency ? ` ${val.currency}` : "";
                    elements.push(`${formattedKey}: ${resolvedValue}${currencyStr}`);
                }
            } else {
                elements.push(`${formattedKey}: ${val}`);
            }
        });

        if (elements.length === 0) return null;

        return (
            <div style={{ padding: '4px' }}>
                {elements.map((text, idx) => (
                    <span key={idx} style={{ fontSize: '11px', color: '#ffffff', display: 'block', whiteSpace: 'nowrap', marginBottom: '4px' }}>
                        {text}
                    </span>
                ))}
            </div>
        );
    };

    const handleDutiesClose = () => {
        setBreakdownAnchorEl(null);
        setSelectedBreakdown(null);
    };
    const inititalColumnSettings={
        "Order" : { "label" : "Order","width" : 300,"index" : 1},
        "Shipment" : {"label" : "Shipment","width" : 300,"index" : 2},
        "Order Status" : {"label" : "Order Status","width" : 150,"index" : 3},
        "Order Date" : {"label" : "Order Date","width" : 150,"index" : 4},
        "Rate" : {"label" : "Rate","width" : 100,"index" : 5},
        "Weight" : {"label" : "Weight","width" : 100,"index" : 6},
        "Sender Name" : {"label" : "Sender Name","width" : 154,"index" : 7},
        "Sender Company" : {"label" : "Sender Company","width" : 100,"index" : 8},
        "Sender Address" : {"label" : "Sender Address","width" : 100, "index" : 9},
        "Sender City" : {"label" : "Sender City","width" : 100,"index" : 10},
        "Sender Province" : {"label" : "Sender Province","width" : 100,"index" : 11},
        "Sender Province Code" : {"label" : "Sender Province Code","width" : 100,"index" : 12},
        "Sender Postal Code" : {"label" : "Sender Postal Code","width" : 100,"index" : 13},
        "Sender Country" : {"label" : "Sender Country","width" : 100,"index" : 14},
        "Sender Country Code" : {"label" : "Sender Country Code","width" : 100,"index" : 15},
        "Receiver Name" : {"label" : "Receiver Name","width" : 100,"index" : 16},
        "Receiver Company" : {"label" : "Receiver Company","width" : 100,"index" : 17},
        "Receiver Address" : {"label" : "Receiver Address","width" : 100,"index" : 18},
        "Receiver City" : {"label" : "Receiver City","width" : 100,"index" : 19},
        "Receiver Province" : {"label" : "Receiver Province","width" : 100,"index" : 20},
        "Receiver Province Code" : {"label" : "Receiver Province Code", "width" : 100,"index" : 21},
        "Receiver Postal Code" : { "label" : "Receiver Postal Code","width" : 100,"index" : 22},
        "Receiver Country" : {"label" : "Receiver Country","width" : 100, "index" : 23},
        "Receiver Country Code" : {"label" : "Receiver Country Code", "width" : 100,"index" : 24},
        "Early Location" : { "label" : "Early Location","width" : 100,"index" : 25},
        "Goods Out Note" : {"label" : "Goods Out Note","width" : 100,"index" : 26},
        "Tags" : {"label" : "Tags", "width" : 100,"index" : 27},
        "Platform" : {"label" : "Platform","width" : 100,"index" : 28},
        "Customer" : {"label" : "Customer","width" : 100,"index" : 29},
        "Platform Tags" : {"label" : "Platform Tags","width" : 100,"index" : 30},
        "Reference No" : {"label" : "Reference No","width" : 100,"index" : 31},
        "Action" : {"label" : "Action","width" : 177,"index" : 32}
    }
    const initialBoxValues = {
        "_id":0,
        "box_name": 'custom',
        "box_length": "",
        "box_width": "",
        "box_height": "",
        "box_dimension_unit": "",
        "box_actual_weight": "",
        "box_weight_unit": "",
        "insurance_amount":"100"
    }
    const [dimensionValue, setDimensionValue] = useState(initialBoxValues);
    const [dimensionsErrors, setDimensionsErrors] = useState({});
    const initialCooValues = {
        "coo": "",
        "hs_tariff_code": "",
        "update":"All"
    }
    const [coovalues, setCooValues] = useState(initialCooValues);
    const [cooerrors, setCooErrors] = useState({});

    // Helper to format HS Code: 1234.56.78.90
    const formatHsCode = (val) => {
        const raw = val.replace(/\D/g, '').slice(0, 10);
        if (raw.length === 10) {
            return `${raw.slice(0, 4)}.${raw.slice(4, 6)}.${raw.slice(6, 8)}.${raw.slice(8, 10)}`;
        }
        return val;
    };

    const cooValidator = (fieldValues = coovalues) => {
        let temp = { ...cooerrors };
        
        // Validate HS Code length if user started typing
        if ('hs_tariff_code' in fieldValues) {
            const raw = fieldValues.hs_tariff_code.replace(/\D/g, '');
            temp.hs_tariff_code = (raw.length > 0 && raw.length !== 10) 
                ? "HS Code must be 10 digits." 
                : "";
        }

        setCooErrors(temp);

        // Form is valid if NO HS errors AND (COO is present OR HS is present)
        const hasData = coovalues.coo !== "" || coovalues.hs_tariff_code !== "";
        return temp.hs_tariff_code === "" && hasData;
    };

    const handleHsBlur = () => {
        const formatted = formatHsCode(coovalues.hs_tariff_code);
        setCooValues(prev => ({ ...prev, hs_tariff_code: formatted }));
    };
    const onChangeCountry = id => {
        setCooValues({
            ...coovalues,
            ['coo']: id
        })
        setCooErrors({ "coo": "" })
    }
    const onChangeCooUpdate = (e) => {
        setCooValues({
            ...coovalues,
            ['update']: e.target.value
        })
    }
    const getSelectedCountry = (country_code) => {
        let filteredValue = { code: "", name: "" };
        filteredCountryData.map((key) => {
          if (key.code == country_code) {
            filteredValue = key;
          }
        });
         return filteredValue;
      };

    const handleSubmit = e => {
        e.preventDefault()
        const isValid = cooValidator(coovalues)
        if (isValid) {
            let bulkid={}
            bulkid["docids"] = bulkCooOrderIds;
            Object.assign(coovalues, bulkid);
            dispatch(bulkReferenceCooUpdateData(profile.id,coovalues))
            setCooValues(initialCooValues)
            setCooErrors({})
            setBulkCooOrderIds([])
            setCooModalVisible(false)
        }
    }

    const filterOptions = createFilterOptions({
        matchFrom: 'start',
        stringify: (option) => option.box_name,
      });

    const getChooseMeasurement = (currentvalue) => {
    let filteredCurrentValue = {};
    let tempValue = "";
    boxData &&
    boxData.map((key) => {
        if (key._id == currentvalue && tempValue == "") {
            filteredCurrentValue = key;
            tempValue = "success";
        }
        });
    return filteredCurrentValue;
    };

    const onBoxDimensionChange=(event)=>{
        let packageFieldData = {...dimensionValue};
        if(event.target.name==='choosenmeasurement'){
            if (event.target.value != 0) {
                box && box.data && box.data.map((boxData) => {
                    if (boxData._id === event.target.value) {
                        setDimensionValue({
                            ...dimensionValue,
                            "_id": event.target.value,
                            "box_name": boxData.box_name,
                            "box_length": parseFloat(boxData.box_length).toFixed(2),
                            "box_width": parseFloat(boxData.box_width).toFixed(2),
                            "box_height": parseFloat(boxData.box_height).toFixed(2),
                            "box_dimension_unit": boxData.box_length_unit,
                            "box_actual_weight": parseFloat(boxData.box_weight).toFixed(2),
                            "box_weight_unit": boxData.box_weight_unit,
                            "insurance_amount": "100"
                        });
                        setDimensionsErrors({})
                    }
                })
            }else{
                setDimensionValue({
                    ...dimensionValue,
                    "_id":0,
                    "box_name": 'custom',
                    "box_length": "",
                    "box_width": "",
                    "box_height": "",
                    "box_dimension_unit": "",
                    "box_actual_weight": "",
                    "box_weight_unit": "",
                    "insurance_amount": "100"
                });
                setDimensionsErrors({})
            }
        }else{
            packageFieldData[event.target.name] = event.target.value;
            setDimensionValue(packageFieldData);
            validator({ [event.target.name]: event.target.value })
        }
    }
    const validator = (fieldValues) => {
        let temp = { ...dimensionsErrors }
        if ('box_name' in fieldValues)
            temp.box_name = fieldValues.box_name ? "" : "This field is required."
        if (fieldValues && fieldValues.box_name && fieldValues.box_name.length < 3)
            temp.box_name = "Box Name required minimum 3 characters"
        if ('box_length' in fieldValues)
            temp.box_length = fieldValues.box_length ? "" : "This field is required."
        if (fieldValues && fieldValues.box_length && fieldValues.box_length <= 0)
            temp.box_length = "Length is not a negative number or 0"
        if ('box_dimension_unit' in fieldValues)
            temp.box_dimension_unit = fieldValues.box_dimension_unit ? "" : "This field is required."
        if ('box_width' in fieldValues)
            temp.box_width = fieldValues.box_width ? "" : "This field is required."
        if (fieldValues && fieldValues.box_width && fieldValues.box_width <= 0)
            temp.box_width = "Width is not a negative number  or 0"
        if ('box_height' in fieldValues)
            temp.box_height = fieldValues.box_height ? "" : "This field is required."
        if (fieldValues && fieldValues.box_height && fieldValues.box_height <= 0)
            temp.box_height = "Height is not a negative number  or 0"
        if ('box_actual_weight' in fieldValues)
            temp.box_actual_weight = fieldValues.box_actual_weight ? "" : "This field is required."
        if (fieldValues && fieldValues.box_actual_weight && fieldValues.box_actual_weight <= 0)
            temp.box_actual_weight = "Weight is not a negative number  or 0"
        if ('box_weight_unit' in fieldValues)
            temp.box_weight_unit = fieldValues.box_weight_unit ? "" : "This field is required."

        setDimensionsErrors({
            ...temp
        })

        if (fieldValues === dimensionValue)
            return Object.values(temp).every(x => x == "")
    }

    const addBulkDimensionsForm =(ids,values)=>{
        const isValid = validator(values)
        if (isValid) {
            let docid={'docids':ids}
            Object.assign(values, docid);
            dispatch(updateBulkDimension(profile.id,values,meta))
            setBulkDimensionModalVisible(false);
            setDimensionValue(initialBoxValues)
            setDimensionsErrors({})
        }
    }


    const deleteOrdersValues =()=>{
        setDeleteOrdersModalVisible(false)
        dispatch(postdeleteOrdersData(profile.id,{"order_docids":deleteOrderIds}))
    }

    let urlParams=""
    const params = new URLSearchParams(window.location.search)
    urlParams = params.get('report')

    const onColumnResizeCustom =(params,event,details)=>{
        setDatagridSave(false)
        let ordersDataGridConfigNew = JSON.parse(JSON.stringify({...ordersDataGridConfig}));
        if(params.colDef.headerName in ordersDataGridConfigNew){
            ordersDataGridConfigNew[params.colDef.headerName]['width']=params.colDef.width;
            ordersDataGridConfigNew[params.colDef.headerName]['index']=parseInt(params.element.ariaColIndex)-1;
        }else{
            ordersDataGridConfigNew[params.colDef.headerName]={
                "label":params.colDef.headerName,
                "width":params.colDef.width,
                "index":parseInt(params.element.ariaColIndex)-1
            }
        }
        setOrdersDataGridConfig(ordersDataGridConfigNew);
    }
    const onColumnReorderingCustom =(params,event,details)=>{
        setDatagridSave(false)
        let ordersDataGridConfigNew = JSON.parse(JSON.stringify({...ordersDataGridConfig}));
        if(params.column.headerName in ordersDataGridConfigNew){
            ordersDataGridConfigNew[params.column.headerName]['width']=params.column.width;
            ordersDataGridConfigNew[params.column.headerName]['index']=parseInt(params.targetIndex);
        }else{
            ordersDataGridConfigNew[params.column.headerName]={
                "label":params.column.headerName,
                "width":params.column.width,
                "index":parseInt(params.targetIndex)
            }
        }
        if(parseInt(params.targetIndex)!==parseInt(params.oldIndex)){
            Object.keys(ordersDataGridConfigNew).map(function(key) {
                if(ordersDataGridConfigNew[key]["label"]!==params.column.headerName){
                    if(parseInt(params.targetIndex)<parseInt(params.oldIndex)){
                        if('index' in ordersDataGridConfigNew[key] && ordersDataGridConfigNew[key]["index"]>=parseInt(params.targetIndex) && ordersDataGridConfigNew[key]["index"]<=parseInt(params.oldIndex)){
                            ordersDataGridConfigNew[key]["index"]=ordersDataGridConfigNew[key]["index"]+1;
                        }
                    }else{
                        if('index' in ordersDataGridConfigNew[key] && ordersDataGridConfigNew[key]["index"]<=parseInt(params.targetIndex) && ordersDataGridConfigNew[key]["index"]>=parseInt(params.oldIndex)){
                            ordersDataGridConfigNew[key]["index"]=ordersDataGridConfigNew[key]["index"]-1;
                        }
                    }
                }
            })
        }
        setOrdersDataGridConfig(ordersDataGridConfigNew);
    }
    const onDatagridSave =()=>{
        let orderDataConfig = {};
        orderDataConfig['report_name']="orders";
        orderDataConfig['fields']=ordersDataGridConfig;
        dispatch(storeDatagridData(profile.id,orderDataConfig))
    }

    const initialDimValues = {
        "length": "",
        "width": "",
        "height": "",
        "dimension_unit": "",
        "actual_weight": "",
        "weight_unit": "",
        "use_actual_weight":false,
    }
    const [defaultBoxDim, setDefaultBoxDim] = useState(initialDimValues)

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
    };
    const tagstyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        bgcolor: 'background.paper'
    };
    let defaultColumns = [{
        field: 'order.id',
        headerName: 'Order',
        headerClassName: 'super-app-theme--header',
        width: 180,
        sortable: true,
        renderCell: (params) => {
            if(params && params.row && params.row.order && params.row.order.id){
                return (
                    <Typography 
                        onClick={e => { orderCallback(params.row.order.id, params.row) }}
                        sx={{ 
                            color: '#1976d2', // --- SNAPPED TO CORPORATE BRAND ACCENT COLOR ---
                            cursor: 'pointer',
                            fontSize: '13.5px',
                            fontWeight: 700,
                            display: 'inline-flex',
                            alignItems: 'center',
                            height: '100%',
                            transition: 'color 0.15s ease-in-out',
                            '&:hover': {
                                color: '#115293',
                                textDecoration: 'underline'
                            }
                        }}
                    >
                        {params.row.order.id}
                    </Typography>
                );
            }else{
                return (
                    <Typography 
                        sx={{ 
                            color: '#1976d2', 
                            fontSize: '13.5px',
                            fontWeight: 700,
                            display: 'inline-flex',
                            alignItems: 'center',
                            height: '100%'
                        }}
                    >
                        -
                    </Typography>
                );
            }
        }
    },
    {
        field: 'line_items.tracking_number',
        headerName: 'Shipment',
        width: 300,
        sortable: false,
        renderCell: (params) => {
            const row = params.row;
            const lineItems = row?.line_items || [];

            // 1. Get unique Master Tracking Numbers only
            const uniqueMasters = [...new Set(lineItems
                .map(item => item.shipment?.master_tracking_number)
                .filter(tkn => tkn && tkn !== "") // Remove null/empty
            )];

            const uniqueCount = uniqueMasters.length;

            // 2. Check if any shipment is marked as multi-piece
            const hasMultiPieceFlag = lineItems.some(item => item.shipment?.is_multi_piece === true);

            // 3. Logic based on Master Tracking Count
            if (uniqueCount > 1) {
                // More than one unique master tracking number (e.g., Purolator + UniExpress)
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                        <MultipleTracking 
                            trackingItems={lineItems}  
                            dispatchCallback={trackingCallback} 
                            carrierImageWidth="60px" 
                            moreCallBack={() => lineItemsDrawerOpen(row)} 
                            orderData={row} 
                            is_multi_piece={hasMultiPieceFlag}
                        />
                    </Box>
                );
            } else if (uniqueCount === 1) {
                // Exactly one master tracking number
                const firstItem = lineItems.find(i => i.shipment?.master_tracking_number === uniqueMasters[0]);
                
                const tracking = { 
                    "tracking_number": uniqueMasters[0], 
                    "carrier_name": firstItem?.fulfilment_company ?? "" 
                };

                return (
                    <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                        <CarrierTracking 
                            trackingItems={tracking} 
                            dispatchCallback={trackingCallback} 
                            carrierImageWidth="60px"  
                            is_multi_piece={hasMultiPieceFlag}
                        />
                    </Box>
                );
            }

            // fallback if no master tracking exists
            return (
                <Typography sx={{ color: '#94A3B8', fontWeight: 500, fontSize: '13.5px', display: 'flex', alignItems: 'center', height: '100%' }}>
                    -
                </Typography>
            );
        }
    },
    {
        field: 'action',
        headerName: 'Action',
        width: 350,
        sortable: false,
        headerAlign: 'left',
        align: 'center',
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => {
            let row = params.row;
            return (
                <Stack 
                    direction="row" 
                    spacing={1.5} 
                    alignItems="center" 
                    justifyContent="center"
                    sx={{ 
                        height: '100%',
                        width: '100%'
                    }}
                >
                    {/* 1. Prime Label Creation CTA Action Trigger */}
                    <Tooltip title="Create Shipment" placement="top">
                        <Button
                            variant="outlined"
                            disabled={createShipmentButton(row)}
                            onClick={() => newOrderCreateCallback(row)}
                            startIcon={<AddCircleOutlineRoundedIcon />}
                            sx={{
                                textTransform: 'none',
                                borderRadius: '8px',
                                fontWeight: 700,
                                fontSize: '13px',
                                py: 0.6,
                                px: 2,
                                transition: 'all 0.15s ease-in-out',
                                color: createShipmentButton(row) ? 'rgba(0,0,0,.38)' : '#1976d2', // --- CORPORATE ACCENT MATRIX SYNC ---
                                borderColor: createShipmentButton(row) ? '#E2E8F0' : '#1976d2',
                                pointerEvents: createShipmentButton(row) ? 'none' : 'auto',
                                cursor: createShipmentButton(row) ? 'not-allowed' : 'pointer',
                                '&:hover': {
                                    borderColor: '#115293',
                                    backgroundColor: 'rgba(25, 118, 210, 0.04)',
                                    color: '#115293'
                                }
                            }}
                        >
                            Label
                        </Button>
                    </Tooltip>

                    {/* 2. Secondary Administrative Pipeline Extended Action Popover Trigger */}
                    <Tooltip title="More Actions" placement="top">
                        <IconButton 
                            onClick={(event) => handleViewMoreActionClick(event, row)}
                            sx={{
                                borderRadius: '8px',
                                border: '1px solid #E2E8F0',
                                p: 0.8,
                                color: '#475569',
                                backgroundColor: '#FFFFFF',
                                transition: 'all 0.15s ease-in-out',
                                '&:hover': {
                                    backgroundColor: '#F1F5F9',
                                    borderColor: '#CBD5E1',
                                    color: '#1E293B'
                                }
                            }}
                        >
                            <MoreHorizRoundedIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </Stack>
            );
        }
    }
]
    const [columns, setColumns] = useState(defaultColumns);

    useEffect(() => {
        if (showFilter === true)
            dispatch(fetchDistinctCarriers())
        dispatch(fetchPlatformTags())
    }, [dispatch, showFilter])

    useEffect(() => {
        dispatch(fetchOrdersUI())
        dispatch(fetchOrderColumns())
        dispatch(fetchLineItemsWeight())
        dispatch(fetchProfile())
        dispatch(fetchTagData())
        dispatch(fetchCountry());
        dispatch(resetOrderNotifications())
        setOnPageSearch(false)
        setMeta(prevState => ({
            ...prevState,
            [`sku`]: "",
            [`order_id`]: "",
            [`tracking_number`]: "",
            [`customer_name`]: "",
            [`page`]: 1,
            [`reference_no`]: "",
            [`goods_out_note`]: "",
            [`receiver_province`]: "",
            [`receiver_country_code`]: ""
        }));
    }, [dispatch])

    useEffect(() => {
        if(urlParams=="openorders"){
            seturlParam(urlParams)
        }else if(urlParams=="returnorders"){
            seturlParam(urlParams)
        }else{
            seturlParam("")
            if (_.has(meta, 'columns'))
                dispatch(fetchOrders({ ...meta }));
        }
    }, [urlParams,dispatch])

    useEffect(() => {
        if (_.has(meta, 'columns'))
            dispatch(fetchOrders({ ...meta }));
            setSelectItemTextVisible(false)
            setSelectItemView(false);
    }, [dispatch, meta])

    useEffect(() => {
        if (orders.bulkLabel && orders.bulkLabel.filename && orders.bulkLabel.filename !== "" && orders.bulkLabel.is_shown === false) {
            setPrintUrl(process.env.REACT_APP_LABELINGCHIMP_LABEL_API_DOMAIN + "/merge-pdf?filename=" + orders.bulkLabel.filename)
            setIsPrinted(false)
        }
    }, [orders.bulkLabel])

    useEffect(() => {
        if (cooUpdate  && cooUpdate.loading===false && cooUpdate.notification && cooUpdate.notification.messageContent && cooUpdate.notification.messageContent[0]==='Line Items updated successfully') {
            dispatch(fetchOrders({ ...meta }));
        }
    }, [cooUpdate])

    useEffect(() => {
        let boxdimensionTemp={}
        if (box && box.data && box.data.length !== 0) {
            box.data.map((item) => {
                if (item.box_default === true) {
                    setDefaultBoxDim({
                        "length": parseFloat(item.box_length).toFixed(2),
                        "width": parseFloat(item.box_width).toFixed(2),
                        "height": parseFloat(item.box_height).toFixed(2),
                        "dimension_unit": item.box_length_unit,
                        "actual_weight": parseFloat(item.box_weight).toFixed(2),
                        "weight_unit": item.box_weight_unit,
                        "choosenmeasurement": item._id,
                        "insurance_amount": "100",
                        "use_actual_weight":item.use_actual_weight
                    })
                }
                if(!(item.box_name in boxdimensionTemp)){
                    boxdimensionTemp[item.box_name.toUpperCase()]=item
                }
            })
            setcustomboxDimensions(boxdimensionTemp)
            let boxData = box && box.data.filter(function( obj ) {
                return  obj.country;
             });
             setBoxValues(boxData)
        }

        let tempBoxData=[]
        let customValue={"_id":0,"box_name":"custom"}
        tempBoxData.push(customValue)
        let boxOriginalData = box && box.data.filter(function( obj ) {
            return  obj.hide !== true;
            });
        if (boxOriginalData.length !== 0) {
            boxOriginalData.map((item) => {
                tempBoxData.push(item)
            })
            setBoxData(tempBoxData)
        }else{
            setBoxData(tempBoxData)
        }
    }, [box && box.data]);

    useEffect(() => {
        setDatagridSave(true)
        if (orderUIUpdate.loading===false && orderUIUpdate && orderUIUpdate.data && orderUIUpdate.data.fields) {
           setOrdersDataGridConfig(orderUIUpdate.data.fields)
        }
        else{
            if(orderUIUpdate.loading===false && orderUIUpdate && orderUIUpdate.data && typeof orderUIUpdate.data.fields==='undefined'){
                setOrdersDataGridConfig(inititalColumnSettings)
            }
        }
    }, [orderUIUpdate])

    useEffect(() => {
       
        if (orders.ordersColumns.columns && typeof orders.ordersColumns.columns.user_columns !== "undefined" && orderUIUpdate.loading===false && orderUIUpdate && orderUIUpdate.data) {
            if (orders.ordersColumns.columns.user_columns.length !== 0) {
                setMeta(prevState => ({
                    ...prevState,
                    [`columns`]: JSON.stringify(orders.ordersColumns.columns.user_columns)
                }));
                Object.entries(orders.ordersColumns.columns.user_columns).map(([key, value]) => (
                    defaultColumns.splice(defaultColumns.length - 1, 0, {
                        field: value,
                        width: 100,
                        sortable: true,
                        headerName: key,
                        headerClassName: 'super-app-theme--header',
                        renderCell: (params) => {
                            if (key === "Platform Tags") {
                                let tagsArray = getValueFromObject("row." + value, params);
                                if (Array.isArray(tagsArray) && tagsArray.length > 0) {
                                    const joinArray = tagsArray.join('\n')
                                    let formatedTag = tagsArray.map((tag) => {
                                        return (
                                            <Tooltip title={<div style={{ whiteSpace: 'normal' }}>{joinArray}</div>}>
                                                <Chip
                                                    size="small"
                                                    label={tag}
                                                    style={{ fontSize: "9px" }}
                                                />
                                            </Tooltip>
                                        );
                                    })
                                    return formatedTag
                                } else if (tagsArray && !Array.isArray(tagsArray) && tagsArray !== "") {
                                    return (
                                        <Tooltip title={tagsArray}>
                                            <Chip
                                                size="small"
                                                label={tagsArray}
                                                style={{ fontSize: "9px" }}
                                            />
                                        </Tooltip>
                                    );
                                } else {
                                    return ""
                                }
                            }else if (key === "Order Date") {
                                return <Date date={params.row.order.date} />
                            }else if (key === "Order Status") {
                                return  <OrderStatus orderStatus={params.row.order.status} />
                            }else if (key === "Rate" || key === "Shipment Rate") {
                                // 1. Priority Check: First look for total_billed, then fallback to total_rate
                                let billedRate = "-";

                                if (params.row && params.row.shipment_summary) {
                                    if (params.row.shipment_summary.total_billed !== undefined && params.row.shipment_summary.total_billed !== null  && params.row.shipment_summary.total_billed >0 ) {
                                        // Use total_billed if it exists
                                        billedRate = params.row.shipment_summary.total_billed;
                                    } else if (params.row.shipment_summary.total_rate) {
                                        // Fallback to total_rate
                                        billedRate = params.row.shipment_summary.total_rate;
                                    }
                                }

                                // 2. Check for multi-piece flag within any of the line items
                                const isMultiPieceFlag = params.row.line_items?.some(item => item.shipment?.is_multi_piece === true) || false;

                                // 3. Return the component with updated props
                                return (
                                    <ShipmentRate 
                                        billed_rate={billedRate} 
                                        api_rate={null} 
                                        is_multi_piece={isMultiPieceFlag} 
                                        is_voided={null} 
                                    />
                                );
                            }else if (key === "Duties") {
                                // 1. Get the rate and ensure it's a valid number, otherwise default to "-"
                                const billedRate = (params.row && params.row.shipment_summary && params.row.shipment_summary.total_duty_charge) 
                                    ? params.row.shipment_summary.total_duty_charge 
                                    : "-";

                                // 2. Check for multi-piece flag within any of the line items
                                const isMultiPieceFlag = params.row?.line_items?.some(item => item.shipment?.is_multi_piece === true) || false;

                                // Has valid duties value
                                const hasDutiesValue = billedRate !== "-" && parseFloat(billedRate) > 0;

                                // 3. Return the component
                                return (
                                    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', gap: 1, justifyContent: 'space-between' }}>
                                        <ShipmentRate 
                                            billed_rate={billedRate} 
                                            api_rate={null} 
                                            is_multi_piece={isMultiPieceFlag} 
                                            is_voided={null} 
                                        />
                                        {hasDutiesValue && (
                                            <IconButton 
                                                size="small" 
                                                onClick={(e) => handleDutiesClick(e, params.row)}
                                                sx={{ color: '#919eab', p: 0.2, position:'relative',right:20 }}
                                            >
                                                <InfoIcon sx={{ fontSize: 16}} />
                                            </IconButton>
                                        )}
                                    </Box>
                                );
                            }else if (key === "Quantity") {
                                let total_quantity = params.row && params.row.total_quantity
                                return total_quantity
                            }else if (key === "Weight") {
                                let totalWeight = 0;
                                let weightUnit = "";
                                
                                // 1. Get line items and create a Set to track processed shipment IDs
                                const lineItems = params.row?.line_items || [];
                                const processedShipmentIds = new Set();

                                lineItems.forEach(item => {
                                    const shipment = item.shipment;
                                    
                                    // 2. Only process if shipment exists and haven't handled this shipment_id yet
                                    if (shipment && shipment.shipment_id && !processedShipmentIds.has(shipment.shipment_id)) {
                                        
                                        // 3. Since shipment.product_info is an ARRAY (based on your JSON), map through it
                                        const productInfos = Array.isArray(shipment.product_info) 
                                            ? shipment.product_info 
                                            : [shipment.product_info];

                                        productInfos.forEach(pInfo => {
                                            if (pInfo && pInfo.actual_weight) {
                                                totalWeight += parseFloat(pInfo.actual_weight);
                                                
                                                // Capture unit from the first valid piece found
                                                if (!weightUnit) {
                                                    weightUnit = pInfo.weight_unit || "";
                                                }
                                            }
                                        });
                                        
                                        // 4. Mark this unique shipment as processed
                                        processedShipmentIds.add(shipment.shipment_id);
                                    }
                                });

                                // 5. Fallback: If no shipment objects found, use the top-level line_item weight
                                if (processedShipmentIds.size === 0) {
                                    lineItems.forEach(item => {
                                        if (item.actual_weight) {
                                            totalWeight += parseFloat(item.actual_weight);
                                            if (!weightUnit) weightUnit = item.weight_unit || "";
                                        }
                                    });
                                }

                                return (
                                    <span>
                                        {totalWeight > 0 
                                            ? `${totalWeight.toFixed(2)} ${weightUnit}` 
                                            : '-'}
                                    </span>
                                );
                            }else{
                                return getValueFromObject("row." + value, params)
                            }
                        }
                    })
                ))
            } else {
                setMeta(prevState => ({
                    ...prevState,
                    [`columns`]: "",
                }));
            }
            if(orderUIUpdate && orderUIUpdate.data && orderUIUpdate.data.fields && Object.keys(orderUIUpdate.data.fields).length>0){
                for (let [key, value] of Object.entries(orderUIUpdate.data.fields)) {
                    let output='';
                    let index='';
                    let field = defaultColumns.filter(function(x) {
                        return x.headerName === key;
                    })[0];
                    index = defaultColumns.indexOf(field);
                    output = defaultColumns.filter(({ headerName }) =>[key].includes(headerName));
                    if(output.length===1){
                        var tmp = defaultColumns.splice(index, 1);
                        tmp[0].width=value.width
                        defaultColumns.splice(value.index-1, 0, tmp[0]);
                    }
                }
            }
        }
        setColumns(defaultColumns)
    }, [orders.ordersColumns && orders.ordersColumns.columns, orders.bulkLabel, orderUIUpdate])

    useEffect(() => {
        if (orders && orders.ordersData && orders.ordersData.data && orders.ordersData.data.length === 0) {
            setCheckedIds([]);
            setCheckedItems([]);
            setDimensionValue(initialBoxValues)
            setDimensionsErrors({})
            setNotes("")
        }else{
            if(orders && orders.ordersData && orders.ordersData.data && orders.ordersData.data.length === 1 && orders.ordersData.meta && orders.ordersData.meta.order_id===orders.ordersData.data[0].order.id && onPageSearch===true){
                let orderitem=orders.ordersData.data[0];
                setOnPageSearch(true)
                if(profile && profile.auto_label_generate ===true && onPageSearch){
                    if(autoLabelOpen && orderitem && (typeof orderitem.line_items =='undefined' || orderitem.line_items.length==0) && (profile && profile.disable_create_shipment ===false || typeof profile.disable_create_shipment == "undefined")){
                        newOrderCreateCallback(orders.ordersData.data[0])
                    }else if (autoLabelOpen && orderitem && orderitem.line_items && orderitem.line_items.length !== 0 && (profile && profile.disable_create_shipment ===false || typeof profile.disable_create_shipment == "undefined")) {
                        orderitem.line_items.forEach(function (key) {
                            if (!key.tracking_number || key.tracking_number === "") {
                                newOrderCreateCallback(orders.ordersData.data[0])
                            }
                        });
                    }
                }
            }
            setSelectItemTextVisible(false)
            setSelectItemView(false);
            handleViewMoreActionClose();
        }
    }, [orders && orders.ordersData && orders.ordersData.data])

    useEffect(() => {
        if (orders && orders.deleteOrders && orders.deleteOrders.data && orders.deleteOrders.data.non_voided_tracking_numbers && orders.deleteOrders.data.manifest_closed_tracking_numbers && orders.deleteOrders.data.billed_tracking_numbers || (orders.deleteOrders.data.non_voided_tracking_numbers >0 || 
            orders.deleteOrders.data.manifest_closed_tracking_numbers >0 || orders.deleteOrders.data.billed_tracking_numbers >0 || orders.deleteOrders.notification.messageContent==='Orders successfully deleted')
        ) {
            let notdeletedTrackingnumbers=[];
            if(orders.deleteOrders.data.manifest_closed_tracking_numbers.length>0){
                orders.deleteOrders.data.manifest_closed_tracking_numbers.map((item) => {
                    notdeletedTrackingnumbers.push({
                        "tracking_number":item,
                        "reason":"Manifest closed tracking number"
                    })
                })
            }
            if(orders.deleteOrders.data.billed_tracking_numbers.length>0){
                orders.deleteOrders.data.billed_tracking_numbers.map((item) => {
                    notdeletedTrackingnumbers.push({
                        "tracking_number":item,
                        "reason":"Billed tracking number"
                    })
                })
            }
            if(orders.deleteOrders.data.non_voided_tracking_numbers.length>0){
                orders.deleteOrders.data.non_voided_tracking_numbers.map((item) => {
                    notdeletedTrackingnumbers.push({
                        "tracking_number":item,
                        "reason":"Non voided tracking number"
                    })
                })
            }
            if(notdeletedTrackingnumbers.length>0){
                setDeleteOrdersModalVisible(true)
            }
           setNotDeletedOrders(notdeletedTrackingnumbers)
        }
    }, [orders && orders.deleteOrders && orders.deleteOrders.data])

    useEffect(() => {
        // 1. Check if we have data and loading has finished
        const labelData = orders?.orderShipmentLabel?.data;
        const isLoading = orders?.orderShipmentLabel?.loading;
       
        if (!isLoading && labelData && Object.keys(labelData).length > 0) {
            
            const trackingNo = labelData.active_tracking_number;
            const requestType = labelData.type;
            if (requestType === "return") {
                // Call the Return logic
                returnOrderCreateCallback(labelData, true, trackingNo);
            } else {
                // Default to Normal Duplicate logic
                newOrderCreateCallback(labelData, true, trackingNo);
            }
        }
    }, [orders.orderShipmentLabel.data, orders.orderShipmentLabel.loading]);

    const openLabelButtonView = (item) => {
        let labelsNotExists = true;

        // 1. Check if line_items exist
        if (item && item.line_items && Array.isArray(item.line_items)) {
            
            // 2. Iterate through line items to find at least one valid shipment
            for (const lineItem of item.line_items) {
                
                // 3. Check if 'shipment' object exists AND it is not voided
                if (
                    lineItem.shipment && 
                    lineItem.shipment.shipment_id && 
                    lineItem.shipment.is_voided === false
                ) {

                    // A valid shipment record was found
                    labelsNotExists = false;
                    break; // Exit loop early
                }
            }
        }

        return labelsNotExists;
    };
    const returnlabelButton = (item) => {
        let isreturnlabelButtonDisable = false;
        const lineItems = item?.line_items || [];

        // 1. Check if any line item has shipment data
        const hasAnyShipment = lineItems.some(li => li.shipment && li.shipment.shipment_id);

        if (hasAnyShipment) {
            // Use a Set to track unique shipment IDs to avoid redundant checks
            let processedShipments = new Set();
            let allShipmentsDisabled = true;

            for (const lineItem of lineItems) {
                const ship = lineItem.shipment;
                
                if (ship && ship.shipment_id && !processedShipments.has(ship.shipment_id)) {
                    processedShipments.add(ship.shipment_id);

                    // Logic: A shipment is "disabled" if it's already a return OR it's voided
                    const isCurrentlyDisabled = (ship.is_return === true || ship.is_voided === true);

                    if (!isCurrentlyDisabled) {
                        // If we find even ONE shipment that is NOT a return and NOT voided, 
                        // the button should be ENABLED (not disabled)
                        allShipmentsDisabled = false;
                        break; 
                    }
                }
            }
            isreturnlabelButtonDisable = allShipmentsDisabled;
        } else {
            // 2. Fallback logic: If no shipment object exists but a tracking_number string is present
            // (matching your second 'if' block logic)
            const hasTrackingString = lineItems.some(li => li.tracking_number && li.tracking_number !== "");
            
            if (hasTrackingString) {
                isreturnlabelButtonDisable = false;
            } else {
                // No tracking and no shipment object means we can't create a return
                isreturnlabelButtonDisable = true;
            }
        }

        return isreturnlabelButtonDisable;
    };

    const openLabelClick = (item) => {
        // Use the correct key from your document
        const docId = item?._id || item?.doc_id;
        
        if (docId) {
            dispatch(fetchOrderShipmentDetails(docId));
        }
    }

    useEffect(() => {
        const details = orders.orderShipmentDetails;

        // 1. Check if loading is finished and data exists
        if (!details.loading && details.data) {
            let labels = [];

            // 2. Convert everything to an array so we can use the same logic
            // If data is an array, use it; if it's a single object, wrap it in []
            const shipments = Array.isArray(details.data) ? details.data : [details.data];

            // 3. Loop through all shipments (works for 1 or many)
            shipments.forEach((shipmentData) => {
                const label = shipmentData?.label;
                if (label) {
                    // Priority: url_direct -> url_carrier -> others
                const url = label?.url_direct || 
                            label?.url_carrier || 
                            label?.url || 
                            label?.url_detachable || 
                            label?.url_direct_detachable;

                    if (url && url !== "" && label.is_voided === false) {
                        if (!labels.includes(url)) {
                            labels.push(url);
                        }
                    }
                }
            });

            // 4. Trigger Printing
            if (labels.length === 1) {
                setPrintUrl(labels[0]);
                setIsPrinted(false);
                dispatch(clearOrderShipmentDetails()); // Clear state by resetting loading or data
            } else if (labels.length > 1) {
                dispatch(printBulkLabels(labels, profile.id));
                dispatch(clearOrderShipmentDetails()); // Clear state
            }else{
                dispatch(clearOrderShipmentDetails());
            }
        }
    }, [orders.orderShipmentDetails.data, orders.orderShipmentDetails.loading]);

    const orderCallback = (item, order = null, invalidids = null) => {
        dispatch(fetchOrderDetail(item));
        if(order==null || order==''){
            order = orders && orders.ordersData && orders.ordersData.data.filter(row => row.order.id==item);
        }
        setOrderRow(order)
        setOrderId(item)
        setInvalidDocIds(invalidids)
        setOrderDrawerVisible(true)
    }

    const handleViewActionClick = (event) => {
        setViewActionAnchorEl(event.currentTarget);
    }

    const handleViewMoreActionClick = (event,row) => {
        setViewMoreActionsRow(row)
        setViewMoreActionAnchorEl(event.currentTarget);
    }

    const handleViewActionClose = () => {
        setViewActionAnchorEl(null);
    }

    const handleViewMoreActionClose = () => {
        setViewMoreActionsRow([]);
        setViewMoreActionAnchorEl(null);
    }

    const handleDuplicateActionClick = (event, row) => {
        setDuplicateActionAnchorEl(event.currentTarget);
    }

    const handleDuplicateActionClose = () => {
        setDuplicateActionAnchorEl(null);
    }

    const handleReturnActionClick = (event, row) => {
        setReturnActionAnchorEl(event.currentTarget);
    }

    const handleReturnActionClose = () => {
        setReturnActionAnchorEl(null);
    }

    const orderOnClose = () => {
        setOrderDrawerVisible(false);
    }

    const lineItemsDrawerClose = () => {
        setLineItemsDrawerVisible(false);
    }

    const lineItemsDrawerOpen = (item) => {
        if (item && item._id) {
            // Dispatch the action with the order_docid (_id)
            dispatch(fetchOrderShipments(item._id));
            setLineItemsDrawerVisible(true); // Open your UI drawer
        }
        setLineItemsData(item);
        setLineItemsDrawerVisible(true);
    }

    // const initiateRecording = (order_id) => {
    //     if(typeof order_id !== undefined && order_id != ""){
    //         console.log("session recording started");
    //         console.log("++++++++++++++++++++++++++++++++++++++++++++++");
    //         console.log(order_id);
    //         console.log(profile.email);
    //         console.log("++++++++++++++++++++++++++++++++++++++++++++++");
    //         window.SessionRecorder.start(order_id, { customer_email: profile.email });
    //     }
    // }

    // const initiateRecording = (tag) => {
    //     try {
    //         if (window.SessionRecorder && typeof window.SessionRecorder.start === 'function' && tag) {
    //             window.SessionRecorder.start(tag, { customer_email: profile?.email || "unknown" });
    //         }
    //     } catch (err) {
    //         console.warn("SessionRecorder failed to start:", err.message);
    //     }
    // }

    const newOrderCreateCallback = (item, is_duplicate_order = false) => {
        // let recordingTag = "New Order";
        // if (item && item.order?.id) {
        //     recordingTag = is_duplicate_order ? `Duplicate Order ${item.order.id}` : `Order ${item.order.id}`;
        // }

        // initiateRecording(recordingTag);
        // Set Flow logic
        if (item !== "" && is_duplicate_order === false) {
            setIsShipmentCreationFlow(true);
        } else {
            setIsShipmentCreationFlow(false);
        }
        setNewOrderFormData(item);
        setNewOrderCreateDrawerVisible(true)
        setIsDuplicateOrder(is_duplicate_order)
        setDuplicateActionAnchorEl(null);
    }
    const returnOrderCreateCallback = (item, is_return,tracking_number) => {
        // if(item && typeof item["order"]["id"] !== "undefined"){
        //     const orderId = item?.order?.id || "Unknown";
        //     initiateRecording(`Return Order ${orderId}`);
        // }
        setNewOrderFormData(item);
        setChoosenTrackingNumber(tracking_number)
        setNewOrderCreateDrawerVisible(true)
        setIsShipmentCreationFlow(false)
        setIsReturnOrder(is_return)
        setReturnActionAnchorEl(null);
    }

    // const stopRecording = () => {
    //     try {
    //         // Check if the SessionRecorder object and stop method exist
    //         if (window.SessionRecorder && typeof window.SessionRecorder.stop === 'function') {
    //             window.SessionRecorder.stop();
    //         }
    //     } catch (err) {
    //         // This CATCHES the SecurityError and RangeError so the rest of your code runs
    //         console.warn("SessionRecorder could not stop due to browser security policy, but code execution will continue.");
    //     }
    // };

    const newOrderCreateOnClose = () => {
        // stopRecording();
        setNewOrderCreateDrawerVisible(false);
        dispatch(clearOrderShipmentLabel());

    }

    const trackingCallback = (carriername, trackingNumber, message = null,is_multi_piece) => {
        let apikey = (profile && profile.api_token) ? profile.api_token : "";
        setTrackingMessage(message)
        const data = { "carrier_name": carriername, 'tracking_number': trackingNumber }
        dispatch(fetchTrackingDetail(data, apikey))
        setTrackingDrawerVisible(true)
        setIsMultiPiece(is_multi_piece)

    }
    const updateAssignTagHandle = (ids,value) => {
        let data={}
        data={
            'docids':ids,
            'tag':value
        }
        dispatch(updateAssignTag(profile && profile.id,data,meta))
        setTagModalVisible(false);
        setAssignTagValue("");
        setAssignTagIds("");
    }
    
    const onClose = () => {
        setTrackingDrawerVisible(false);
    };

    const onChangePerPage = (event) => {
        setPageNumber('')
        setMeta({
            ...meta,
            ...{
                page: 1,
                per_page: event.target.value
            }
        });
    }

    const onChangePagination = (event, page) => {
        setPageNumber("")
        setMeta({
            ...meta,
            ...{
                page: page
            }
        });
    }
    const onInputChangePagination = (page) => {
        setPageNumber(page)
        let pagenumber = ''
        if (page == '') {
            pagenumber = 1
        } else {
            pagenumber = page
        }
        setMeta({
            ...meta,
            ...{
                page: pagenumber
            }
        });
    }

    const updateDynamicColumns = (clear = false) => {
        let data = columnCheckedObject
        if (clear === true) {
            data = {}
            setColumnCheckedObject({})
        }
        dispatch(saveOrdersColumns(profile && profile.id,data))
    }

    const onMenuClick = (type, show) => {
        setShowSearch((type === "search" && show === true) ? true : false)
        setShowFilter((type === "filter" && show === true) ? true : false)
        if(show === true){
            setOnPageSearch(true)
        }
    }

    const onExportClick = () => {
        const qs = Object.keys(meta)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(meta[key])}`)
            .join('&');
            console.log(qs)
        let url = process.env.REACT_APP_API_DOMAIN + '/labelgen/orders/export?' + qs;
        window.open(url,"_blank")
    }

    const handleColumnsClick = (event) => {
        setAnchorEl(event.currentTarget);
        setShowDynamicColumn(!showDynamicColumn)
    };

    const handleActionsClick = (event) => {
        setActionAnchorEl(event.currentTarget);
    };

    const handleColumnsClose = () => {
        setAnchorEl(null);
        setShowDynamicColumn(!showDynamicColumn)
    };

    const checkBoxCompute = (tempCheckedIds, tempCheckedItems, item, currentSelectedIds) => {
        const index = tempCheckedIds.indexOf(item._id);
        const method = (currentSelectedIds.indexOf(item._id) > -1)
        if (method) {
            if (index === -1) {
                tempCheckedIds.push(item._id);
                tempCheckedItems.push(item)
            }
        } else if (!method) {
            if (index > -1) {
                tempCheckedIds.splice(index, 1);
                tempCheckedItems.splice(index, 1);
            }
        }
        return [tempCheckedIds, tempCheckedItems];
    }

    const onSortChange = (currentSorting) => {
        setMeta({
            ...meta,
            ...{
                sorting: JSON.stringify(currentSorting)
            }
        });
    }

    const onSelectionChange = (currentSelectedIds, currentAllItems) => {
        let currentSelectedIdsLength= currentSelectedIds.length;
        let currentAllItemsLength= currentAllItems.length;
        let tempCheckedIds = [...checkedIds]
        let tempCheckedItems = [...checkedItems];
        currentAllItems.map((item) => (
            checkBoxCompute(tempCheckedIds, tempCheckedItems, item, currentSelectedIds)
        ))
        setCheckedIds(tempCheckedIds)
        setCheckedItems(tempCheckedItems)
        if(currentSelectedIdsLength===currentAllItemsLength){
            setTotalOrders(orders && orders.ordersData && orders.ordersData.meta && orders.ordersData.meta.total)
            setTotalSelectedItems(tempCheckedIds.length)
            setSelectItemTextVisible(true)
        }else{
            setSelectItemTextVisible(false)
            setSelectItemView(false)
        }
    }

    const handleBulkSelectedOrders = () => {
       let bulkOrderMeta=meta
       let bulkOrderMetaData = {...bulkOrderMeta, per_page: 2500};
       let bulkOrderMetaData1 = {...bulkOrderMetaData, page: 1};
        dispatch(fetchBulkSelectedOrders(bulkOrderMetaData1))
        setSelectItemView(true)
    }
    
    const handleClearOrders = () => {
        setCheckedIds([])
        setCheckedItems([])
        setSelectItemView(false)
        setSelectItemTextVisible(false)
    }
    

    const handleActionClose = () => {
        setActionAnchorEl(null);
    }
    const errorColumns = [
        { 
            field: 'orderid',
            headerName: 'Order Id',
            flex: 1,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                if (params?.row?.orderid && params?.row?.type && params.row.type === 'Miscellaneous') {
                    return (
                        <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#475569' }}>
                            {params.row.orderid}
                        </Typography>
                    );
                } else if (params?.row?.orderid) {
                    let orderdatavalue = "";
                    return (
                        <Typography 
                            onClick={e => orderCallback(params.row.orderid, orderdatavalue, bulkvalidationOrdersData.data)}
                            sx={{ 
                                fontSize: '13px', 
                                fontWeight: 700, 
                                color: '#1976d2', // --- SEAMLESS ENTERPRISE BRANDING INTEGRATION ---
                                cursor: 'pointer',
                                display: 'inline-block',
                                transition: 'color 0.15s ease-in-out',
                                '&:hover': { 
                                    color: '#115293',
                                    textDecoration: 'underline'
                                } 
                            }} 
                        >
                            {params.row.orderid}
                        </Typography>
                    );
                } else {
                    return <Typography sx={{ color: '#94A3B8', fontSize: '13px' }}>-</Typography>;
                }
            }
        },
        { 
            field: 'reason',
            headerName: 'Failure Reason',
            flex: 1,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => (
                <Typography 
                    sx={{ 
                        fontSize: '13px', 
                        fontWeight: 500, 
                        color: '#64748B',
                        whiteSpace: 'normal',
                        lineHeight: 1.4,
                        display: 'flex',
                        alignItems: 'center',
                        height: '100%'
                    }}
                >
                    {params.value || "-"}
                </Typography>
            )
        }
    ];
    const notDeletedColumns = [
        { 
            field: 'tracking_number',
            headerName: 'Tracking Number',
            flex:1
        },
        { 
            field: 'reason',
            headerName: 'Failure Reason',
             flex:1,
        }
    ]
    const errorTable = (errorvalues) => {
        return (
            <Card 
                variant="outlined" 
                sx={{ 
                    mt: 2.5, 
                    borderRadius: '12px', 
                    borderColor: '#F1F5F9',
                    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.02)',
                    overflow: 'hidden',
                    width: '100%'
                }}
            >
                <DataGrid 
                    sx={{
                        border: 'none',
                        backgroundColor: '#FFFFFF',
                        '& .super-app-theme--header': {
                            backgroundColor: '#F8FAFC',
                            color: '#475569',
                            fontWeight: 700,
                            fontSize: '12px',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px',
                            borderBottom: '1px solid #E2E8F0'
                        },
                        '& .MuiDataGrid-cell': {
                            borderBottom: '1px solid #F1F5F9',
                            py: 1.5
                        },
                        '& .MuiDataGrid-row:hover': {
                            backgroundColor: '#F8FAFC'
                        },
                        '& .MuiDataGrid-footerContainer': {
                            borderTop: '1px solid #E2E8F0',
                            backgroundColor: '#F8FAFC',
                            minHeight: '40px'
                        },
                        '& .MuiTablePagination-root': {
                            color: '#64748B'
                        }
                    }}
                    getRowId={(row) => row.docIds}
                    rows={errorvalues || []}
                    columns={errorColumns}
                    rowHeight={52}
                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 5,
                            },
                        },
                    }}
                    autoHeight
                    pageSizeOptions={[5]}
                    disableColumnFilter
                    disableColumnMenu
                    disableRowSelectionOnClick
                />
            </Card>
        );
    };
    const notDeleteOrdersTable=(values) =>{
        return (
            <>
                <DataGrid style={{marginTop:'20px'}}
                getRowId={(row) => row.tracking_number}
                rows={values}
                columns={notDeletedColumns}
                initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 5,
                      },
                    },
                  }}
                  autoHeight={true}
                  pageSizeOptions={[5]}
                  disableColumnFilter={true}
                  disableColumnMenu={true}
                  disableRowSelectionOnClick={true}
                />
                </>
            )
    }
    const createShipmentButton = (item) => {
        let createShipmentButtonDisable = true;

        // 1. Check if the user is allowed to create shipments via profile settings
        const isProfileAllowed = (profile && profile.disable_create_shipment === false) || 
                                (typeof profile?.disable_create_shipment === "undefined");

        if (item && isProfileAllowed) {
            // 2. Scenario A: If there are no line items at all, allow creating a shipment (Custom Shipment)
            if (!item.line_items || item.line_items.length === 0) {
                createShipmentButtonDisable = false;
            } 
            // 3. Scenario B: If there are line items, check if any item is still unfulfilled
            else {
                // .some() returns true if at least ONE item meets the condition
                const hasUnfulfilledItem = item.line_items.some(lineItem => 
                    !lineItem.tracking_number || lineItem.tracking_number === ""
                );

                if (hasUnfulfilledItem) {
                    createShipmentButtonDisable = false;
                }
            }
        }

        return createShipmentButtonDisable;
    };

    const createShipmentBulkData = () => {

        if (addresssender && addresssender.data && addresssender.data.length == 0) {
            setModalVisible(false)
            setOpenSenderAddressModal(true)
            return false;
        } else if (addresssender && addresssender.data && addresssender.data.length != 0) {
            let defaultSenderAddressFound = false
            addresssender.data.map((addressData) => {
                if (addressData && addressData.default) {
                    defaultSenderAddressFound = true
                }
            })
            if (defaultSenderAddressFound == false) {
                setModalVisible(false)
                setOpenSenderAddressModal(true)
                return false;
            }
        }

        if (addressbilling && addressbilling.data && addressbilling.data.length == 0) {
            setModalVisible(false)
            setOpenBillingAddressModal(true)
            return false;
        }

        let datas = '';
        if(selectItemView===true){
            datas = bulkSelectedOrdersData && bulkSelectedOrdersData.data
        }else{
            datas = checkedItems
        }
        let bulkShipmentRequestData = []
        datas.forEach((item) => {
            let row = typeof item == "object" ? JSON.parse(JSON.stringify(item)) : {}
            if (bulkvalidationOrdersData && bulkvalidationOrdersData.data && Object.keys(bulkvalidationOrdersData.data).length!==0) {
                for (let key = 0; key < bulkvalidationOrdersData.data.valid_order_docids.length; key++) {
                    if (row._id===bulkvalidationOrdersData.data.valid_order_docids[key]){
                        bulkShipmentRequestData.push(bulkvalidationOrdersData.data.valid_order_docids[key])
                    }
                }
            }// Orders with tracking numbers will be skipped
        })
        setModalVisible(false)
        if (bulkShipmentRequestData.length !== 0) {
                let finalBulkOrderData={
                    "order_docids":bulkShipmentRequestData,
                    "bulk_reference_id": "",
                    "notes":notes,
                    "subuser_id":profile.id
                }
                setActionAnchorEl(null);
                dispatch(dopostDataBulkShipment(profile.id,finalBulkOrderData, profile.api_token, { ...meta }))
                onSelectionChange([], orders.ordersData.data)
        } else {
            setModalDetails("novalidcreateshipment")
            setModalVisible(true)
            return false
        }
    }

    const manifestCloseBulkData = () => {
        let trackingNumbers = []
        if (bulkvalidationOrdersData && bulkvalidationOrdersData.data && Object.keys(bulkvalidationOrdersData.data).length!==0) {
            for (let key = 0; key < bulkvalidationOrdersData.data.valid_tracking_nos.length; key++) {
                if (!trackingNumbers.includes(bulkvalidationOrdersData.data.valid_tracking_nos[key])) {
                    trackingNumbers.push(bulkvalidationOrdersData.data.valid_tracking_nos[key])
                }
            }
        }
        setModalVisible(false)
        if (trackingNumbers.length !== 0) {
            var postData = {
                "tracking_numbers": trackingNumbers,
                "ignore_errors": true,
                "request_medium":"UI",
                "subuser_id":profile.id
            }
            dispatch(dopostTrackingNumberCloseManifest(profile.id,postData, profile.api_token, { ...meta }))
            setActionAnchorEl(null);
            onSelectionChange([], orders.ordersData.data)
        }
    }

    const voidShipmentBulkData = () => {
        let trackingNumbers = []
        let doc_ids = []
        if (bulkvalidationOrdersData && bulkvalidationOrdersData.data && Object.keys(bulkvalidationOrdersData.data).length!==0) {
            for (let key = 0; key < bulkvalidationOrdersData.data.valid_tracking_nos.length; key++) {
                if (!trackingNumbers.includes(bulkvalidationOrdersData.data.valid_tracking_nos[key])) {
                    trackingNumbers.push(bulkvalidationOrdersData.data.valid_tracking_nos[key])
                }
            }
        }
        setModalVisible(false)
        if (trackingNumbers.length !== 0) {
            var postData = {
                "tracking_numbers": trackingNumbers,
                "ignore_errors": true,
                "request_medium":"UI",
                "subuser_id":profile.id
            }
            var updateOrderData = { "doc_ids": doc_ids, "update_type": "void" }
            dispatch(doPostTrackingNumberVoid(profile.id,postData, profile.api_token, updateOrderData, { ...meta }))
            setActionAnchorEl(null);
            onSelectionChange([], orders.ordersData.data)
        }
    }

    const printLabelBulk = () => {
        // Collect unique _ids from checked items
        const orderDocIds = checkedItems
            .map(item => item._id || item.doc_id)
            .filter(id => id != null);

        if (orderDocIds.length > 0) {
            // This triggers the API to get all URLs for these orders
            dispatch(fetchBulkOrderShipmentDetails(orderDocIds));
        } else {
            setModalDetails("novalidlabel");
            setModalVisible(true);
        }
    };
    
    const printPackageSlip = () => {
        let ids = []
        checkedItems.forEach((item) => {
            let row = typeof item == "object" ? JSON.parse(JSON.stringify(item)) : {}
            if (row && row.line_items && row.line_items.length !== 0) {
                ids.push(item._id)
            }
        })
        if (ids.length !== 0) {
            if(profile && profile.label_size_packaging_slip && profile.label_size_packaging_slip==true){
                setPrintUrl(process.env.REACT_APP_INTEGRATIONS_API_DOMAIN + "/package-customslip-order?doc_id=" + ids.toString())
            }else{
                setPrintUrl(process.env.REACT_APP_INTEGRATIONS_API_DOMAIN + "/package-slip-order?doc_id=" + ids.toString())
            }
            setIsPrinted(false)
        }
    }

    const printOrderSummary = () => {
        let ids = []
        checkedItems.forEach((item) => {
            let row = typeof item == "object" ? JSON.parse(JSON.stringify(item)) : {}
            if (row && row.line_items && row.line_items.length !== 0) {
                ids.push(item._id)
            }
        })
        if (ids.length !== 0) {
            if(profile && profile.label_size_packaging_slip && profile.label_size_packaging_slip==true){
                setPrintUrl(process.env.REACT_APP_INTEGRATIONS_API_DOMAIN + "/custom-order-details-print?doc_id=" + ids.toString())
            }else{
                setPrintUrl(process.env.REACT_APP_INTEGRATIONS_API_DOMAIN + "/custom-order-details-print?doc_id=" + ids.toString())
            }
            setIsPrinted(false)
        }
    }

    const assignTag = () => {
        let ids = []
        let datas = '';
        if(selectItemView===true){
            datas = bulkSelectedOrdersData && bulkSelectedOrdersData.data
        }else{
            datas = checkedItems
        }
        datas.forEach((item) => {
            let row = typeof item == "object" ? JSON.parse(JSON.stringify(item)) : {}
            if (row && row.line_items && row.line_items.length !== 0) {
                ids.push(item._id)
            }
        })
        setAssignTagIds(ids)
        setTagModalVisible(true)
           
    }

    const addbulkdimension = () => {
        let ids = []
        let datas = '';
        if(selectItemView===true){
            datas = bulkSelectedOrdersData && bulkSelectedOrdersData.data
        }else{
            datas = checkedItems
        }
        datas.forEach((item) => {
            let row = typeof item == "object" ? JSON.parse(JSON.stringify(item)) : {}
            if (row && row.line_items && row.line_items.length !== 0) {
                ids.push(item._id)
            }
        })
        setBulkDimensionIds(ids)
        setBulkDimensionModalVisible(true)
    }
    const deleteordersData = () => {
        let ids = []
        let datas = '';
        if(selectItemView===true){
            datas = bulkSelectedOrdersData && bulkSelectedOrdersData.data
        }else{
            datas = checkedItems
        }
        datas.forEach((item) => {
            let row = typeof item == "object" ? JSON.parse(JSON.stringify(item)) : {}
            if (row && row.order && row.order.id) {
                ids.push(item._id)
            }
        })
        setDeleteOrderIds(ids)
        setDeleteOrdersModalVisible(true)
    }
    const bulkCooUpdateData = () => {
        let ids = []
        let datas = '';
        if(selectItemView===true){
            datas = bulkSelectedOrdersData && bulkSelectedOrdersData.data
        }else{
            datas = checkedItems
        }
        datas.forEach((item) => {
            let row = typeof item == "object" ? JSON.parse(JSON.stringify(item)) : {}
            if (row && row.order && row.order.id) {
                ids.push(item._id)
            }
        })
        setBulkCooOrderIds(ids)
        setCooModalVisible(true)
    }

    const createShipmentOrderValidate=()=>{
        let datas='';
        if(selectItemView===true){
            datas = bulkSelectedOrdersData && bulkSelectedOrdersData.data
        }else{
            datas = checkedItems
        }
        let orderIdDatas=[]
        datas.forEach((item) => {
                let row = typeof item == "object" ? JSON.parse(JSON.stringify(item)) : {}
                let docids=row && row._id;
                orderIdDatas.push(docids)
        })
        let final_data={
            "order_docids":orderIdDatas,
            "request_type":"CREATE_SHIPMENT"
        }
        if(orderIdDatas.length>0){
            dispatch(postBulkOrderValidation(profile.id,final_data))
        }
    }

    const bulkVoidOrderValidate=()=>{
        let datas='';
        if(selectItemView===true){
            datas = bulkSelectedOrdersData && bulkSelectedOrdersData.data
        }else{
            datas = checkedItems
        }
        let orderIdDatas=[]
        datas.forEach((item) => {
                let row = typeof item == "object" ? JSON.parse(JSON.stringify(item)) : {}
                let docids=row && row._id;
                orderIdDatas.push(docids)
        })
        let final_data={
            "order_docids":orderIdDatas,
            "request_type":"VOID"
        }
        if(orderIdDatas.length>0){
            dispatch(postBulkOrderValidation(profile.id,final_data))
        }
    }

    const getModelDescription = (type) => {
        let counts=""
        let description = ""
        if(modalDetails === "voidshipment"){
            if(bulkvalidationOrdersData && bulkvalidationOrdersData.data &&  Object.keys(bulkvalidationOrdersData.data).length!==0){
                counts=bulkvalidationOrdersData && bulkvalidationOrdersData.data
                let validOorderIdsCount=parseInt(counts.valid_order_count)
                let invalidOorderIdsCount=parseInt(counts.invalid_order_count)
                let totalCount=validOorderIdsCount+invalidOorderIdsCount
                description = counts.valid_order_count + " out of " + totalCount + " were eligible for void"
            }
        }else if(modalDetails === "closemanifest"){
            if(bulkvalidationOrdersData && bulkvalidationOrdersData.data &&  Object.keys(bulkvalidationOrdersData.data).length!==0){
                counts=bulkvalidationOrdersData && bulkvalidationOrdersData.data
                let validOorderIdsCount=parseInt(counts.valid_order_count)
                let invalidOorderIdsCount=parseInt(counts.invalid_order_count)
                let totalCount=validOorderIdsCount+invalidOorderIdsCount
                description = counts.valid_order_count + " out of " + totalCount + " were eligible for manifest close"
            }
        }else if (modalDetails === "shipment") {
            if(bulkvalidationOrdersData && bulkvalidationOrdersData.data &&  Object.keys(bulkvalidationOrdersData.data).length!==0){
                counts=bulkvalidationOrdersData && bulkvalidationOrdersData.data
                let validOorderIdsCount=parseInt(counts.valid_order_docids.length)
                let invalidOorderIdsCount=parseInt(counts.invalid_order_docids.length)
                let totalCount=validOorderIdsCount+invalidOorderIdsCount
                description = counts.valid_order_docids.length + " out of " + totalCount + " were eligible to create shipment"

            }
        }
        return description
    }

    const modalDetailsCollection = {
        lessthanone: {
            description: "Please select atleast one orders.",
            onOk: () => setModalVisible(false)

        },
        morethanthousand: {
            description: "Please select less than or equal to thousand.",
            onOk: () => setModalVisible(false)
        },
        shipment: {
            title: "Create Shipment",
            description: getModelDescription("createshipment"),
            note: "Already created shipments will get ignored.",
            onOk: createShipmentBulkData
        },
        closemanifest: {
            title: "Manifest Close",
            description: getModelDescription("manifestclose"),
            note: "Already closed shipments will get ignored.",
            onOk: manifestCloseBulkData

        },
        voidshipment: {
            title: "Void Shipment",
            description: getModelDescription("voidshipment"),
            note: "Already voided shipments will get ignored.",
            onOk: voidShipmentBulkData

        },
        geneartelabel: {
            title: "Print Label",
            description: "Already printed label will be ignored.",
            onOk: printLabelBulk
        },
        novalidcreateshipment: {
            title: "Create Shipment",
            description: "All orders selected have shipments.",
            onOk: () => setModalVisible(false)
        },
        novalidlabel: {
            title: "Print Label",
            description: "All the selected orders are not eligible to print labels",
            onOk: () => setModalVisible(false)
        },
        default: {
            title: "",
            description: null,

        }
    }

    const groupAction = (method) => {
        if (checkedIds && checkedIds.length < 1) {
            setModalVisible(true)
            setModalDetails("lessthanone")
            return false
        }
        if (checkedIds && checkedIds.length > 1000) {
            setModalVisible(true)
            setModalDetails("morethanthousand")
            return false
        }
        if (method === "creatshipment") {
            setModalVisible(true)
            setModalDetails("shipment")
            return false
        }
        if (method === "manifestclose") {
            setModalVisible(true)
            setModalDetails("closemanifest")
            return false

        }
        if (method === "voidshipment") {
            setModalVisible(true)
            setModalDetails("voidshipment")
            return false
        }

        if (method === "printlabel") {
            printLabelBulk()
        }

        if (method === "printpackageslip") {
            printPackageSlip()
        }

        if (method === "printordersummary") {
            printOrderSummary()
        }

        if (method === "assigntag") {
            assignTag()
        }

        if (method === "addbulkdimension") {
            addbulkdimension()
        }
        if (method === "deleteorders") {
            deleteordersData()
        }
        if (method === "bulkCooUpdate") {
            bulkCooUpdateData()
        }
        handleActionClose()
    }

    const choosenhandleClick = (id) => {
        setChoosenTrackingNumber(id)
    };

    function getValueFromObject(path, sourceObject) {
        let paths = path.split(".")
        try {
            paths.map((key) => (
                sourceObject = sourceObject[key]
            ))
            return sourceObject
        }
        catch (err) {
            return "-"
        }

    }

    function CustomTotalRows() {
        return (
            <Box 
                className="custom-total-rows" 
                sx={{ 
                    display: 'inline-flex', 
                    alignItems: 'center',
                    py: 0.5,
                    px: 1.5,
                    marginTop:'5px',
                    borderRadius: '6px',
                    backgroundColor: '#F1F5F9', // Soft background fill for visual balance in the toolbar
                    border: '1px solid #E2E8F0'
                }}
            >
                <Typography 
                    variant="body2" 
                    sx={{ 
                        fontSize: '12.5px', 
                        fontWeight: 600, 
                        color: '#475569',
                        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                        letterSpacing: '0.1px'
                    }}
                >
                    Showing <strong style={{ color: '#0F172A', fontWeight: 700 }}>
                        {orders && orders.ordersData && orders.ordersData.data && orders.ordersData.data.length}
                    </strong> of <strong style={{ color: '#0F172A', fontWeight: 700 }}>
                        {(orders && orders.ordersData && orders.ordersData.meta && orders.ordersData.meta.total) ? orders.ordersData.meta.total : 0}
                    </strong>
                </Typography>
            </Box>
        );
    }


    function CustomPagesizeoptions() {
        return (
            <Box className="custom-page-size-options" sx={{ display: 'inline-flex', alignItems: 'center' }}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#64748B' }}>
                        Show
                    </Typography>
                    
                    <FormControl 
                        size="small" 
                        variant="outlined" 
                        sx={{
                            minWidth: 75,
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '8px',
                                backgroundColor: '#FFFFFF',
                                transition: 'all 0.2s',
                                border: '1px solid #E2E8F0',
                                '& fieldset': { border: 'none' },
                                '&:hover': { borderColor: '#CBD5E1' },
                                '&.Mui-focused': {
                                    borderColor: '#1976d2',
                                    boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.08)'
                                }
                            },
                            '& .MuiSelect-select': {
                                padding: '6px 10px',
                                fontSize: '13px',
                                fontWeight: 600,
                                color: '#1E293B',
                                textAlign: 'center'
                            }
                        }}
                    >
                        <Select
                            value={meta && meta.per_page}
                            onChange={onChangePerPage}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        borderRadius: '8px',
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                                        border: '1px solid #E2E8F0',
                                        '& .MuiMenuItem-root': {
                                            fontSize: '13px',
                                            fontWeight: 500,
                                            py: 0.8,
                                            color: '#334155',
                                            '&.Mui-selected': {
                                                backgroundColor: 'rgba(25, 118, 210, 0.08)',
                                                color: '#1976d2',
                                                fontWeight: 700
                                            }
                                        }
                                    }
                                }
                            }}
                        >
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={20}>20</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                            <MenuItem value={100}>100</MenuItem>
                            <MenuItem value={500}>500</MenuItem>
                            {/* <MenuItem value={2000}>2000</MenuItem> */}
                        </Select>
                    </FormControl>

                    <Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#64748B' }}>
                        entries
                    </Typography>
                </Stack>
            </Box>
        );
    }

    function CustomToolbar() {
        return (
            <GridToolbarContainer 
                sx={{ 
                    paddingBottom: '50px', 
                    bgcolor: '#F8FAFC', 
                    borderBottom: '1px solid #E2E8F0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: 2
                }}
            >
                <CustomPagesizeoptions />
                <CustomTotalRows />
            </GridToolbarContainer>
        );
    }

    function CustomPagination() {
        return (
            <>
                <GridFooterContainer 
                    style={{ justifyContent: 'end' }}
                    sx={{
                        p: 1.5,
                        bgcolor: '#F8FAFC',
                        borderTop: '1px solid #E2E8F0',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 3,
                        flexWrap: 'wrap',
                        // Styles to modernise the internal layout structure of the Material UI Pagination numbers
                        '& .MuiPaginationItem-root': {
                            fontSize: '13px',
                            fontWeight: 600,
                            borderRadius: '8px',
                            '&.Mui-selected': {
                                backgroundColor: '#1976d2', // --- CORPORATE BLUE BRAND ACCENT COLOR ---
                                color: '#FFFFFF',
                                '&:hover': {
                                    backgroundColor: '#115293'
                                }
                            }
                        }
                    }}
                >
                    <Pagination
                        color="primary"
                        shape="circular"
                        page={orders && orders.ordersData && orders.ordersData.meta && orders.ordersData.meta.page}
                        count={orders && orders.ordersData && orders.ordersData.meta && orders.ordersData.meta.last_page}
                        onChange={onChangePagination}
                    />
                    <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
                        <PageSearch 
                            pagenumber={pageNumber} 
                            lastPage={orders?.ordersData?.meta?.last_page || 1} 
                            getpagenumber={onInputChangePagination} 
                        />
                    </Box>
                </GridFooterContainer>
            </>
        );
    }


    const getFormatedShipmentData = () => {
       let shipmentList = [];
        const lineItems = newOrderFormData?.line_items || [];

        // 1. Collect unique tracking numbers across all line items
        // Using a Set to ensure we don't list the same tracking number multiple times
        const allTracking = lineItems.reduce((acc, item) => {
            const shipment = item.shipment;
            if (shipment?.tracking_numbers) {
                return acc.concat(shipment.tracking_numbers);
            }
            return acc;
        }, []);

        const uniqueTrackingNumbers = [...new Set(allTracking)];

        // 2. Iterate through unique tracking numbers to build the list
        uniqueTrackingNumbers.forEach((trackingNumber) => {
            // Find the specific line item/shipment associated with this tracking number
            const associatedItem = lineItems.find(item => 
                item.shipment?.tracking_numbers?.includes(trackingNumber)
            );
            
            const shipment = associatedItem?.shipment || {};

            // 3. Logic: Disable if the shipment is already a return OR if it is voided
            const isDisabled = shipment.is_return === true || shipment.is_voided === true;

            if (isDisabled) {
                shipmentList.push(
                    <ListItem 
                        key={trackingNumber}
                        style={{ cursor: "not-allowed", pointerEvents: "none", color: "rgba(0,0,0,.54)" }}
                    >
                        <ListItemText primary={trackingNumber} />
                    </ListItem>
                );
            } else {
                shipmentList.push(
                    <ListItem 
                        key={trackingNumber}
                        style={{ cursor: "pointer" }} 
                        onClick={() => {
                            choosenhandleClick(trackingNumber);
                            dispatch(fetchOrderShipmentLabel(newOrderFormData._id, trackingNumber, "duplicate"));
                            
                        }}
                    >
                        <ListItemText primary={trackingNumber} />
                    </ListItem>
                );
            }
        });

        return shipmentList;
    }

    const getFormatedReturnShipmentData = () => {
        let shipmentList = [];
        const lineItems = newOrderFormData?.line_items || [];

        // 1. Collect unique tracking numbers across all line items
        // Using a Set to ensure we don't list the same tracking number multiple times
        const allTracking = lineItems.reduce((acc, item) => {
            const shipment = item.shipment;
            if (shipment?.tracking_numbers) {
                return acc.concat(shipment.tracking_numbers);
            }
            return acc;
        }, []);

        const uniqueTrackingNumbers = [...new Set(allTracking)];

        // 2. Iterate through unique tracking numbers to build the list
        uniqueTrackingNumbers.forEach((trackingNumber) => {
            // Find the specific line item/shipment associated with this tracking number
            const associatedItem = lineItems.find(item => 
                item.shipment?.tracking_numbers?.includes(trackingNumber)
            );
            
            const shipment = associatedItem?.shipment || {};

            // 3. Logic: Disable if the shipment is already a return OR if it is voided
            const isDisabled = shipment.is_return === true || shipment.is_voided === true;

            if (isDisabled) {
                shipmentList.push(
                    <ListItem 
                        key={trackingNumber}
                        style={{ cursor: "not-allowed", pointerEvents: "none", color: "rgba(0,0,0,.54)" }}
                    >
                        <ListItemText primary={trackingNumber} />
                    </ListItem>
                );
            } else {
                shipmentList.push(
                    <ListItem 
                        key={trackingNumber}
                        style={{ cursor: "pointer" }} 
                        onClick={() => {
                            choosenhandleClick(trackingNumber);
                            dispatch(fetchOrderShipmentLabel(newOrderFormData._id, trackingNumber, "return"));
                           
                        }}
                    >
                        <ListItemText primary={trackingNumber} />
                    </ListItem>
                );
            }
        });

        return shipmentList;
    };
    const formattedRate = (shipment, isApiRate) => {
        let shipmentRate = 0
        if (shipment && shipment["rate"] && shipment["rate"]["billed"] && shipment["rate"]["billed"]["total"]) {
            shipmentRate = parseFloat(shipment["rate"]["billed"]["total"])
        } else if (shipment && shipment["rate"] && shipment["rate"]["total_charges"]) {
            shipmentRate = parseFloat(shipment["rate"]["total_charges"])
            isApiRate = true
        } else {
            shipmentRate = 0
        }
        return [shipmentRate, isApiRate]
    }

    const formattedDuty = (shipment, isApiRate) => {
        let shipmentRate = 0
        if (shipment && shipment["rate"] && shipment["rate"]["duty_charges"] && shipment["rate"]["duty_charges"]["total_charge"]) {
            shipmentRate = parseFloat(shipment["rate"]["duty_charges"]["total_charge"])
        } else {
            shipmentRate = 0
        }
        return [shipmentRate, isApiRate]
    }

    const labelButton = (row) => {
        let labelButtonDisable = true;
        if (row &&
            row.label &&
            row.manifest &&
            typeof row.label.is_void_in_progress === "undefined" &&
            (row.label.url_detachable || row.label.url_direct_detachable || row.label.url || row.label.url_direct)
        ) {
            labelButtonDisable = false;
        }
        return labelButtonDisable;
    }

    const getOrderShipmentRate = (shipment, is_multi_piece_order) => {
        let calculatedRate = 0
        let fetchedRateArray = []
        let fetchedRate = 0
        let iteration = 0
        let isApiRate = false
        for (var key of Object.keys(shipment)) {
            let dataTemp = typeof shipment[key] == "object" ? JSON.parse(JSON.stringify(shipment[key])) : {};
            let voided = labelButton(dataTemp)
            if (voided && voided === true) {
                continue;
            }
            if (is_multi_piece_order && dataTemp && dataTemp["label"] && dataTemp["label"]["multi_piece"] && dataTemp["label"]["multi_piece"] === true && typeof dataTemp["label"]["master_tracking_number"]=="undefined" && (typeof dataTemp["label"]["is_multiple_shipment"]=="undefined" || dataTemp["label"]["is_multiple_shipment"] === false)) {
                iteration = iteration + 1;
            }
            if (is_multi_piece_order && dataTemp && dataTemp["label"] && dataTemp["label"]["multi_piece"] && dataTemp["label"]["multi_piece"] === true && iteration > 1 && typeof dataTemp["label"]["master_tracking_number"]=="undefined" && (typeof dataTemp["label"]["is_multiple_shipment"]=="undefined" || dataTemp["label"]["is_multiple_shipment"] === false)) {
                continue;
            }
            dataTemp["tracking_number"] = key;
            fetchedRateArray = formattedRate(dataTemp, isApiRate);
            fetchedRate = (fetchedRateArray[0]) ? fetchedRateArray[0] : 0;
            isApiRate = (fetchedRateArray[1]) ? fetchedRateArray[1] : false;
            calculatedRate = (fetchedRate !== NaN) ? calculatedRate + fetchedRate : calculatedRate;
        }
        if (calculatedRate === 0) {
            return "-"
        }
        calculatedRate = calculatedRate.toFixed(2)
        if (isApiRate) {
            return (
                <ShipmentRate billed_rate={null} api_rate={calculatedRate} is_multi_piece={is_multi_piece_order} is_voided={null} />
            )
        } else {
            return (
                <ShipmentRate billed_rate={calculatedRate} api_rate={null} is_multi_piece={is_multi_piece_order} is_voided={null} />
            )
        }
    }

    const getOrderShipmentDuty = (shipment, is_multi_piece_order) => {
        let calculatedRate = 0
        let fetchedRateArray = []
        let fetchedRate = 0
        let iteration = 0
        let isApiRate = false
        for (var key of Object.keys(shipment)) {
            let dataTemp = typeof shipment[key] == "object" ? JSON.parse(JSON.stringify(shipment[key])) : {};
            let voided = labelButton(dataTemp)
            if (voided && voided === true) {
                continue;
            }
            if (is_multi_piece_order && dataTemp && dataTemp["label"] && dataTemp["label"]["multi_piece"] && dataTemp["label"]["multi_piece"] === true && typeof dataTemp["label"]["master_tracking_number"]=="undefined" && (typeof dataTemp["label"]["is_multiple_shipment"]=="undefined" || dataTemp["label"]["is_multiple_shipment"] === false)) {
                iteration = iteration + 1;
            }
            if (is_multi_piece_order && dataTemp && dataTemp["label"] && dataTemp["label"]["multi_piece"] && dataTemp["label"]["multi_piece"] === true && iteration > 1 && typeof dataTemp["label"]["master_tracking_number"]=="undefined" && (typeof dataTemp["label"]["is_multiple_shipment"]=="undefined" || dataTemp["label"]["is_multiple_shipment"] === false)) {
                continue;
            }
            dataTemp["tracking_number"] = key;
            fetchedRateArray = formattedDuty(dataTemp, isApiRate);
            fetchedRate = (fetchedRateArray[0]) ? fetchedRateArray[0] : 0;
            isApiRate = (fetchedRateArray[1]) ? fetchedRateArray[1] : false;
            calculatedRate = (fetchedRate !== NaN) ? calculatedRate + fetchedRate : calculatedRate;
        }
        if (calculatedRate === 0) {
            return "-"
        }
        calculatedRate = calculatedRate.toFixed(2)
        if (isApiRate) {
            return (
                <ShipmentRate billed_rate={null} api_rate={calculatedRate} is_multi_piece={is_multi_piece_order} is_voided={null} />
            )
        } else {
            return (
                <ShipmentRate billed_rate={calculatedRate} api_rate={null} is_multi_piece={is_multi_piece_order} is_voided={null} />
            )
        }
    }

     useEffect(() => {
            if (orders && orders.createShipment && orders.createShipment.notification && orders.createShipment.notification.messageContent
                && orders.createShipment.notification.messageContent[0] === 'Shipment Created Successfully' ) {
                    setAutoLabelOpen(false)
            }else{
                setAutoLabelOpen(true)
            }
        }, [orders && orders.createShipment]);

    return (
        <>
            {(orders && orders.ordersData && orders.ordersData.notification && orders.ordersData.notification.show) &&
                <Notification
                    is_open={orders.ordersData.notification.show}
                    messageType={orders.ordersData.notification.messageType}
                    messages={orders.ordersData.notification.messageContent}
                    handleClose={() => dispatch(resetOrderNotifications())}
                />}
            {(orders && orders.ordersColumns.notification && orders.ordersColumns.notification.show) &&
                <Notification
                    is_open={orders.ordersColumns.notification.show}
                    messageType={orders.ordersColumns.notification.messageType}
                    messages={orders.ordersColumns.notification.messageContent}
                    handleClose={() => dispatch(resetOrderNotifications())}
                />}
            {(newcreateshipment && newcreateshipment.notification && newcreateshipment.notification.show && newcreateshipment.notification.messageType !== 'success') &&
                <Notification
                    is_open={newcreateshipment.notification.show}
                    messageType={newcreateshipment.notification.messageType}
                    messages={newcreateshipment.notification.messageContent}
                    handleClose={() => dispatch(resetGenerateLabel())}
                />}

            {(orders && orders.createShipment.notification && orders.createShipment.notification.show) &&
                <Notification
                    is_open={orders.createShipment.notification.show}
                    messageType={orders.createShipment.notification.messageType}
                    messages={orders.createShipment.notification.messageContent}
                    handleClose={() => dispatch(resetOrderNotifications())}
                />}
            {(orders && orders.voidShipment.notification && orders.voidShipment.notification.show) &&
                <Notification
                    is_open={orders.voidShipment.notification.show}
                    messageType={orders.voidShipment.notification.messageType}
                    messages={orders.voidShipment.notification.messageContent}
                    handleClose={() => dispatch(resetOrderNotifications())}
                />}
            {(orders && orders.createShipmentBulk.notification && orders.createShipmentBulk.notification.show) &&
                <Notification
                    is_open={orders.createShipmentBulk.notification.show}
                    messageType={orders.createShipmentBulk.notification.messageType}
                    messages={orders.createShipmentBulk.notification.messageContent}
                    handleClose={() => dispatch(resetOrderNotifications())}
                />}
            {(orders && orders.manifestClose.notification && orders.manifestClose.notification.show) &&
                <Notification
                    is_open={orders.manifestClose.notification.show}
                    messageType={orders.manifestClose.notification.messageType}
                    messages={orders.manifestClose.notification.messageContent}
                    handleClose={() => dispatch(resetOrderNotifications())}
                />}
             {(orders && orders.assignTags.notification && orders.assignTags.notification.show) &&
                <Notification
                    is_open={orders.assignTags.notification.show}
                    messageType={orders.assignTags.notification.messageType}
                    messages={orders.assignTags.notification.messageContent}
                    handleClose={() => dispatch(resetOrderNotifications())}
                />}
            {(orders && orders.syncOrderData.notification && orders.syncOrderData.notification.show) &&
            <Notification
                is_open={orders.syncOrderData.notification.show}
                messageType={orders.syncOrderData.notification.messageType}
                messages={orders.syncOrderData.notification.messageContent}
                handleClose={() => dispatch(resetOrderNotifications())}
            />}
            {(orders && orders.orderUIUpdate.notification && orders.orderUIUpdate.notification.show) &&
            <Notification
                is_open={orders.orderUIUpdate.notification.show}
                messageType={orders.orderUIUpdate.notification.messageType}
                messages={orders.orderUIUpdate.notification.messageContent}
                handleClose={() => dispatch(resetOrderNotifications())}
            />}
            {(orders && orders.addBulkDimension.notification && orders.addBulkDimension.notification.show) &&
                <Notification
                    is_open={orders.addBulkDimension.notification.show}
                    messageType={orders.addBulkDimension.notification.messageType}
                    messages={orders.addBulkDimension.notification.messageContent}
                    handleClose={() => dispatch(resetOrderNotifications())}
            />}
            {(orders && orders.deleteOrders.notification && orders.deleteOrders.notification.show) &&
                <Notification
                    is_open={orders.deleteOrders.notification.show}
                    messageType={orders.deleteOrders.notification.messageType}
                    messages={orders.deleteOrders.notification.messageContent}
                    handleClose={() => dispatch(resetOrderNotifications())}
            />}
            {(cooUpdate  && cooUpdate.notification && cooUpdate.notification.show) &&
                    <Notification
                        is_open={cooUpdate.notification.show}
                        messageType={cooUpdate.notification.messageType}
                        messages={cooUpdate.notification.messageContent}
                        handleClose={() => dispatch(resetBulkOrderNotifications())}
             />}
            <Printer isPrinted={isPrinted} setIsPrinted={setIsPrinted} print_url={printUrl} />
            <Popover
                id={actionId}
                open={actionOpen}
                anchorEl={actionAnchorEl}
                onClose={handleActionClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                PaperProps={{
                    sx: {
                        minWidth: 260,
                        maxWidth: 300,
                        borderRadius: '12px',
                        boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -4px rgba(0,0,0,0.05)',
                        border: '1px solid #E2E8F0',
                        mt: 1,
                        overflow: 'hidden'
                    }
                }}
            >
                <List 
                    disablePadding 
                    sx={{ 
                        p: 1,
                        backgroundColor: '#FFFFFF', // --- PREMIUM FLAT SURFACE FOUNDATION COLOR ---
                        '& .MuiListItemButton-root': {
                            borderRadius: '8px',
                            mb: 0.5,
                            py: 1,
                            px: 1.5,
                            transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)', 
                            '&:hover': {
                                backgroundColor: 'rgba(25, 118, 210, 0.06)', // Optimal balance of depth for text readability
                                '& .MuiListItemIcon-root': { 
                                    color: '#1976d2',
                                    transform: 'scale(1.04)' 
                                },
                                '& .MuiListItemText-primary': { 
                                    color: '#1976d2' 
                                }
                            },
                            '&.Mui-disabled': {
                                opacity: 0.38,
                                cursor: 'not-allowed',
                                backgroundColor: 'transparent'
                            }
                        },
                        '& .MuiListItemIcon-root': {
                            minWidth: '36px',
                            color: '#1976d2', 
                            transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)'
                        },
                        '& .MuiListItemText-primary': {
                            fontSize: '13.5px',
                            fontWeight: 600,
                            color: '#334155', // Slate primary provides great contrast against the white canvas
                            transition: 'color 0.2s ease-in-out' 
                        }
                    }}
                >
                    {/* --- GROUP 1: PRINTING & DOCUMENTATION PIPELINES --- */}
                    <ListItemButton 
                        disabled={selectItemView == true && totalOrders > 100 ? true : false} 
                        onClick={() => groupAction("printpackageslip")}
                    >
                        <ListItemIcon><PrintIcon fontSize="small" /></ListItemIcon>
                        <ListItemText primary="Print Packaging Slip" />
                    </ListItemButton>

                    {/* <ListItemButton 
                        disabled={selectItemView == true && totalOrders > 100 ? true : false} 
                        onClick={() => groupAction("printlabel")}
                    >
                        <ListItemIcon><LocalPrintshopIcon fontSize="small" /></ListItemIcon>
                        <ListItemText primary="Print Label" />
                    </ListItemButton> */}

                    <ListItemButton 
                        disabled={selectItemView == true && totalOrders > 100 ? true : false} 
                        onClick={() => groupAction("printordersummary")}
                    >
                        <ListItemIcon><PrintIcon fontSize="small" /></ListItemIcon>
                        <ListItemText primary="Print Order Summary" />
                    </ListItemButton>

                    <Divider sx={{ my: 1, borderColor: '#E2E8F0', borderStyle: 'dashed' }} />

                    {/* --- GROUP 2: SHIPMENT LIFE CYCLE WORKFLOWS --- */}
                    {/* <ListItemButton 
                        disabled={(orders && orders.createShipmentBulk && orders.createShipmentBulk.loading === true || profile && profile.disable_create_shipment === true) ? true : false} 
                        onClick={() => {
                            groupAction("creatshipment");
                            createShipmentOrderValidate();
                            setActionAnchorEl(null);
                        }}
                    >
                        <ListItemIcon><AddCircleOutlineRoundedIcon fontSize="small" /></ListItemIcon>
                        <ListItemText primary="New Shipment" />
                    </ListItemButton> */}

                    {/* <ListItemButton 
                        disabled={orders && orders.voidShipment && orders.voidShipment.loading === true ? true : false} 
                        onClick={() => {
                            groupAction("voidshipment");
                            bulkVoidOrderValidate();
                        }}
                    >
                        <ListItemIcon><DeleteOutlineOutlinedIcon fontSize="small" /></ListItemIcon>
                        <ListItemText primary="Void Shipment" />
                    </ListItemButton> */}

                    <ListItemButton 
                        disabled={orders && orders.manifestClose && orders.manifestClose.loading === true ? true : false} 
                        onClick={() => {
                            groupAction("manifestclose");
                            bulkVoidOrderValidate();
                        }}
                    >
                        <ListItemIcon><AssignmentTurnedInOutlinedIcon fontSize="small" /></ListItemIcon>
                        <ListItemText primary="Close Manifest (Selected)" />
                    </ListItemButton>

                    <Divider sx={{ my: 1, borderColor: '#E2E8F0', borderStyle: 'dashed' }} />

                    {/* --- GROUP 3: METADATA & PARCEL SPECIFICATIONS --- */}
                    <ListItemButton 
                        disabled={tags && tags.loading === true ? true : false} 
                        onClick={() => groupAction("assigntag")}
                    >
                        <ListItemIcon><TagOutlinedIcon fontSize="small" /></ListItemIcon>
                        <ListItemText primary="Assign Tag" />
                    </ListItemButton>

                    <ListItemButton 
                        disabled={tags && tags.loading === true ? true : false} 
                        onClick={() => groupAction("addbulkdimension")}
                    >
                        <ListItemIcon><AllInboxIcon fontSize="small" /></ListItemIcon>
                        <ListItemText primary="Add Bulk Dimensions" />
                    </ListItemButton>

                    <ListItemButton onClick={() => groupAction("bulkCooUpdate")}>
                        <ListItemIcon><LanguageIcon fontSize="small" /></ListItemIcon>
                        <ListItemText primary="Country of Origin Update" />
                    </ListItemButton>

                    <Divider sx={{ my: 1, borderColor: '#E2E8F0', borderStyle: 'dashed' }} />

                    {/* --- GROUP 4: CRITICAL DATA DESTRUCTION ZONE --- */}
                    <ListItemButton 
                        disabled={tags && tags.loading === true ? true : false} 
                        onClick={() => groupAction("deleteorders")}
                        sx={{
                            '& .MuiListItemIcon-root': {
                                color: '#DC2626' // Warning red color state for data deletion profile
                            },
                            '&:hover': {
                                backgroundColor: 'rgba(220, 38, 38, 0.06) !important', // Soft Crimson critical alert fill background
                                '& .MuiListItemIcon-root': { 
                                    color: '#DC2626',
                                    transform: 'scale(1.04)' // Matches layout scaling factor
                                },
                                '& .MuiListItemText-primary': { 
                                    color: '#DC2626' // Snaps text properties to alert state matching
                                }
                            }
                        }}
                    >
                        <ListItemIcon><DeleteForeverOutlinedIcon fontSize="small" /></ListItemIcon>
                        <ListItemText primary="Delete Orders" />
                    </ListItemButton>

                    <Divider sx={{ my: 1, borderColor: '#E2E8F0', borderStyle: 'dashed' }} />

                    {/* --- GROUP 5: UNFULFILLED ORDERS RESYNC WORKFLOW --- */}
                    {urlParam === "openorders" && (
                        <React.Fragment>
                            <Divider sx={{ my: 1, borderColor: '#E2E8F0', borderStyle: 'dashed' }} />

                            <Tooltip title="sync unfulfilled orders from your store" placement="left">
                                <span>
                                    <ListItemButton 
                                        disabled={unfulfilledSyncLoading}
                                        onClick={() => {
                                            handleUnfulfilledOrdersSync();
                                            handleActionClose();
                                        }}
                                    >
                                        <ListItemIcon>
                                            {unfulfilledSyncLoading ? (
                                                <CircularProgress size={18} sx={{ color: '#1976d2' }} />
                                            ) : (
                                                <SyncIcon fontSize="small" />
                                            )}
                                        </ListItemIcon>
                                        <ListItemText primary={unfulfilledSyncLoading ? "Syncing..." : "Resync Orders"} />
                                    </ListItemButton>
                                </span>
                            </Tooltip>
                        </React.Fragment>
                    )}
                </List>
            </Popover>
            <Popover
                id={viewActionId}
                open={viewActionOpen}
                anchorEl={viewActionAnchorEl}
                onClose={handleViewActionClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                PaperProps={{
                    sx: {
                        minWidth: 240,
                        borderRadius: '12px',
                        boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -4px rgba(0,0,0,0.05)',
                        border: '1px solid #E2E8F0',
                        mt: 1,
                        overflow: 'hidden'
                    }
                }}
            >
                <List 
                    disablePadding 
                    onMouseLeave={handleViewActionClose}
                    sx={{ 
                        p: 1.5,
                        '& .MuiListItemButton-root': {
                            borderRadius: '8px',
                            mb: 0.5,
                            py: 0.8,
                            px: 1.5,
                            transition: 'all 0.15s ease-in-out',
                            '&:hover': {
                                backgroundColor: '#F1F5F9',
                            }
                        },
                        '& .MuiListItemIcon-root': {
                            minWidth: '32px',
                            color: '#1976d2' // --- ENTERPRISE BRANDING SYSTEM SYNC ---
                        },
                        '& .MuiListItemText-primary': {
                            fontSize: '13.5px',
                            fontWeight: 600,
                            color: '#334155'
                        }
                    }}
                >
                    {/* --- SECTION 1: PACKAGING SLIPS --- */}
                    <Typography variant="caption" sx={{ px: 1.5, py: 0.5, display: 'block', fontWeight: 700, color: '#94A3B8', textTransform: 'uppercase', letterSpacing: '0.5px', fontSize: '11px' }}>
                        Packaging Slip
                    </Typography>

                    <ListItemButton onClick={() => { window.open(profile && profile.label_size_packaging_slip && profile.label_size_packaging_slip == true ? process.env.REACT_APP_INTEGRATIONS_API_DOMAIN + "/package-customslip-order?doc_id=" + currentViewItem._id : process.env.REACT_APP_INTEGRATIONS_API_DOMAIN + "/package-slip-order?doc_id=" + currentViewItem._id, "_blank"); }}>
                        <ListItemIcon><RemoveRedEyeIcon fontSize="small" /></ListItemIcon>
                        <ListItemText primary="View Slip" />
                    </ListItemButton>

                    <ListItemButton onClick={() => { setPrintUrl(profile && profile.label_size_packaging_slip && profile.label_size_packaging_slip == true ? process.env.REACT_APP_INTEGRATIONS_API_DOMAIN + "/package-customslip-order?doc_id=" + currentViewItem._id : process.env.REACT_APP_INTEGRATIONS_API_DOMAIN + "/package-slip-order?doc_id=" + currentViewItem._id); setIsPrinted(false); }}>
                        <ListItemIcon><LocalPrintshopIcon fontSize="small" /></ListItemIcon>
                        <ListItemText primary="Print Slip" />
                    </ListItemButton>

                    {/* --- SECTION 2: INTERNATIONAL LOGISTICS MANAGEMENT --- */}
                    {currentViewItem && 
                    // 1. Verify shipping address exists and is international (not CA)
                    currentViewItem.shipping_address && 
                    currentViewItem.shipping_address.country_code !== 'CA' &&
                    // 2. Check if there is at least one line item with a valid shipment ID
                    currentViewItem.line_items?.some(item => item.shipment && item.shipment.shipment_id) && (
                        <>   
                            <Divider sx={{ my: 1, borderColor: '#E2E8F0', borderStyle: 'dashed' }} />
                            <Typography variant="caption" sx={{ px: 1.5, py: 0.5, display: 'block', fontWeight: 700, color: '#94A3B8', textTransform: 'uppercase', letterSpacing: '0.5px', fontSize: '11px' }}>
                                International Customs
                            </Typography>

                            <ListItemButton onClick={() => { window.open(process.env.REACT_APP_INTEGRATIONS_API_DOMAIN + "/package-invoice?doc_id=" + currentViewItem._id, "_blank"); }}>
                                <ListItemIcon><RemoveRedEyeIcon fontSize="small" /></ListItemIcon>
                                <ListItemText primary="View Customs Invoice" />
                            </ListItemButton>

                            <ListItemButton onClick={() => { setPrintUrl(process.env.REACT_APP_INTEGRATIONS_API_DOMAIN + "/package-invoice?doc_id=" + currentViewItem._id); setIsPrinted(false); }}>
                                <ListItemIcon><LocalPrintshopIcon fontSize="small" /></ListItemIcon>
                                <ListItemText primary="Print Customs Invoice" />
                            </ListItemButton>
                        </>
                    )}

                    {/* --- SECTION 3: BILLING & RATE METRICS MANIFESTS --- */}
                    {(profile && profile.hide_rate === false || typeof profile.hide_rate == "undefined") && (
                        <>
                            <Divider sx={{ my: 1, borderColor: '#E2E8F0', borderStyle: 'dashed' }} />
                            <Typography variant="caption" sx={{ px: 1.5, py: 0.5, display: 'block', fontWeight: 700, color: '#94A3B8', textTransform: 'uppercase', letterSpacing: '0.5px', fontSize: '11px' }}>
                                Financial Summary
                            </Typography>

                            <ListItemButton onClick={() => { window.open(process.env.REACT_APP_INTEGRATIONS_API_DOMAIN + "/custom-order-details-print?doc_id=" + currentViewItem._id, "_blank"); }}>
                                <ListItemIcon><RemoveRedEyeIcon fontSize="small" /></ListItemIcon>
                                <ListItemText primary="View Order Summary" />
                            </ListItemButton>

                            <ListItemButton onClick={() => { setPrintUrl(process.env.REACT_APP_INTEGRATIONS_API_DOMAIN + "/custom-order-details-print?doc_id=" + currentViewItem._id); setIsPrinted(false); }}>
                                <ListItemIcon><LocalPrintshopIcon fontSize="small" /></ListItemIcon>
                                <ListItemText primary="Print Order Summary" />
                            </ListItemButton>
                        </>
                    )}
                </List>
            </Popover>
            <Popover
                id={duplicateActionId}
                open={duplicateActionOpen}
                anchorEl={duplicateActionAnchorEl}
                onClose={handleDuplicateActionClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                PaperProps={{
                    sx: {
                        minWidth: 260,
                        maxWidth: 320,
                        borderRadius: '12px',
                        boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -4px rgba(0,0,0,0.05)',
                        border: '1px solid #E2E8F0',
                        mt: 1,
                        overflow: 'hidden'
                    }
                }}
            >
                <List 
                    disablePadding
                    onMouseLeave={handleDuplicateActionClose}
                    sx={{ 
                        p: 1.5,
                        '& .MuiListItemButton-root': {
                            borderRadius: '8px',
                            mb: 0.5,
                            py: 1,
                            px: 1.5,
                            transition: 'all 0.15s ease-in-out',
                            '&:hover': {
                                backgroundColor: '#F1F5F9',
                            }
                        },
                        '& .MuiListItemIcon-root': {
                            minWidth: '32px',
                            color: '#1976d2' // --- SYSTEM THEME ACCENT MATRIX SYNC ---
                        },
                        '& .MuiListItemText-primary': {
                            fontSize: '13.5px',
                            fontWeight: 600,
                            color: '#334155'
                        }
                    }}
                >
                    {(() => {
                        const lineItems = newOrderFormData?.line_items || [];
                        
                        // 1. Check if the flag 'is_multi_piece' is true in any line item
                        const hasMultiPieceFlag = lineItems.some(item => item.shipment?.is_multi_piece === true);
                        
                        // 2. Count unique tracking numbers across all line items
                        const allTracking = lineItems.reduce((acc, item) => 
                            acc.concat(item.shipment?.tracking_numbers || []), []);
                        const uniqueTrackingCount = new Set(allTracking).size;

                        // 3. Only render the list if it's a multi-piece shipment or has multiple tracking numbers
                        if (uniqueTrackingCount > 1) {
                            return getFormatedShipmentData();
                        }
                        
                        return null;
                    })()}
                </List>
            </Popover>
            <Popover
                id={returnActionId}
                open={returnActionOpen}
                anchorEl={returnAnchorEl}
                onClose={handleReturnActionClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                PaperProps={{
                    sx: {
                        minWidth: 260,
                        maxWidth: 320,
                        borderRadius: '12px',
                        boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -4px rgba(0,0,0,0.05)',
                        border: '1px solid #E2E8F0',
                        mt: 1,
                        overflow: 'hidden'
                    }
                }}
            >
                <List 
                    disablePadding
                    onMouseLeave={handleReturnActionClose}
                    sx={{ 
                        p: 1.5,
                        '& .MuiListItemButton-root': {
                            borderRadius: '8px',
                            mb: 0.5,
                            py: 1,
                            px: 1.5,
                            transition: 'all 0.15s ease-in-out',
                            '&:hover': {
                                backgroundColor: '#F1F5F9',
                            }
                        },
                        '& .MuiListItemIcon-root': {
                            minWidth: '32px',
                            color: '#1976d2' // --- ENTERPRISE SYSTEM BRAND THEME MATCH ---
                        },
                        '& .MuiListItemText-primary': {
                            fontSize: '13.5px',
                            fontWeight: 600,
                            color: '#334155'
                        }
                    }}
                >
                    {(() => {
                        const lineItems = newOrderFormData?.line_items || [];
                        
                        // 1. Check if the flag 'is_multi_piece' is true in any line item
                        const hasMultiPieceFlag = lineItems.some(item => item.shipment?.is_multi_piece === true);
                        
                        // 2. Count unique tracking numbers across all line items
                        const allTracking = lineItems.reduce((acc, item) => 
                            acc.concat(item.shipment?.tracking_numbers || []), []);
                        const uniqueTrackingCount = new Set(allTracking).size;

                        // 3. Only render the list if it's a multi-piece shipment or has multiple tracking numbers
                        if (uniqueTrackingCount > 1) {
                            return getFormatedReturnShipmentData();
                        }
                        
                        return null;
                    })()}
                </List>
            </Popover>
            <Popover
                id={viewMoreActionId}
                open={viewMoreActionOpen}
                anchorEl={viewMoreActionAnchorEl}
                onClose={handleViewMoreActionClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                PaperProps={{
                    sx: {
                        borderRadius: '12px',
                        boxShadow: '0 4px 20px -2px rgba(0,0,0,0.08), 0 2px 8px -1px rgba(0,0,0,0.04)',
                        border: '1px solid #E2E8F0',
                        mt: 1,
                        overflow: 'hidden'
                    }
                }}
            >
                {/* <Typography sx={{ p: 2 }}>The content of the Popover.</Typography> */}
                <Stack 
                    direction="row" 
                    spacing={0.5} 
                    alignItems="center" 
                    sx={{ 
                        p: 1,
                        bgcolor: '#FFFFFF',
                        '& .MuiIconButton-root': {
                            borderRadius: '8px',
                            p: 1,
                            transition: 'all 0.15s ease-in-out',
                            '&:hover': {
                                backgroundColor: '#F1F5F9',
                            },
                            '&.Mui-disabled': {
                                opacity: 0.4,
                                cursor: 'not-allowed',
                                backgroundColor: 'transparent'
                            }
                        }
                    }}
                >
                    {/* 1. Print Shipping Label Action Trigger */}
                    <Tooltip title="Label" placement="top">
                        <IconButton
                            disabled={openLabelButtonView(viewMoreActionsRow)}
                            style={{
                                color: openLabelButtonView(viewMoreActionsRow) ? 'rgba(0,0,0,.54)' : '#1976d2',
                                cursor: openLabelButtonView(viewMoreActionsRow) ? 'not-allowed' : 'pointer',
                                pointerEvents: openLabelButtonView(viewMoreActionsRow) ? 'none' : 'auto'
                            }}
                            onClick={() => openLabelClick(viewMoreActionsRow)}
                        >
                            <LocalPrintshopIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>

                    {/* 2. Commercial Invoice / Documentation Hub Action */}
                    <Tooltip title="Documents" placement="top">
                        <IconButton onClick={handleViewActionClick}>
                            <InsertDriveFileOutlinedIcon 
                                onClick={() => setCurrentViewItem(viewMoreActionsRow)} 
                                style={{ color: "#1976d2", cursor: 'pointer' }} 
                                fontSize="small"
                            />
                        </IconButton>
                    </Tooltip>

                    {/* 3. Master Manifest Duplication Processing Engine */}
                    <Tooltip title="Duplicate Shipment" placement="top">
                        <IconButton
                            onClick={(event) => {
                                const row = viewMoreActionsRow;
                                const lineItems = row?.line_items || [];
                                
                                // 1. Get truly unique Master Tracking Numbers from the shipments
                                const uniqueMasters = [...new Set(lineItems
                                    .map(item => item.shipment?.master_tracking_number)
                                    .filter(tkn => tkn && tkn !== "")
                                )];

                                const uniqueMasterCount = uniqueMasters.length;
                                
                                // 2. Logic: If there is more than 1 unique master (e.g., UniUni + Purolator)
                                if (uniqueMasterCount > 1) {
                                    // Open the popover to let user choose WHICH master to duplicate
                                    setNewOrderFormData(row); // Ensure Popover has data
                                    handleDuplicateActionClick(event, row);
                                } 
                                // 3. Logic: If there is exactly 1 master tracking number
                                else if (uniqueMasterCount === 1) {
                                    const targetMaster = uniqueMasters[0];
                                    dispatch(fetchOrderShipmentLabel(row._id, targetMaster, "duplicate"));
                                } 
                                // 4. Fallback: No shipment exists yet
                                else {
                                    newOrderCreateCallback(row, true);
                                }
                            }}
                            style={{ color: '#1976d2' }}
                        >
                            <ContentCopyOutlinedIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>

                    {/* 4. Global Return Logistics Lifecycle Manager */}
                    <Tooltip title="Return Shipment" placement="top">
                        <IconButton
                            disabled={returnlabelButton(viewMoreActionsRow)}
                            style={{
                                color: returnlabelButton(viewMoreActionsRow) ? 'rgba(0,0,0,.54)' : '#1976d2',
                                pointerEvents: returnlabelButton(viewMoreActionsRow) ? 'none' : 'auto',
                                cursor: returnlabelButton(viewMoreActionsRow) ? 'not-allowed' : 'pointer'
                            }}
                            onClick={(event) => {
                                const row = viewMoreActionsRow;
                                const lineItems = row?.line_items || [];
                                
                                // 1. Get truly unique Master Tracking Numbers from all shipments
                                const uniqueMasters = [...new Set(lineItems
                                    .map(item => item.shipment?.master_tracking_number)
                                    .filter(tkn => tkn && tkn !== "")
                                )];

                                const uniqueMasterCount = uniqueMasters.length;

                                // 2. Logic: If there is more than 1 unique master (e.g., UniUni + Purolator)
                                if (uniqueMasterCount > 1) {
                                    // Store the row data so the Return Popover knows what to display
                                    setNewOrderFormData(row);
                                    // Open the manual selection dialog
                                    handleReturnActionClick(event, row);
                                } 
                                // 3. Logic: If there is exactly 1 master shipment
                                else if (uniqueMasterCount === 1) {
                                    const targetMaster = uniqueMasters[0];
                                    dispatch(fetchOrderShipmentLabel(row._id, targetMaster, "return"));
                                }
                            }}
                        >
                            <KeyboardReturnOutlinedIcon 
                                onClick={() => {
                                    const lineItems = viewMoreActionsRow?.line_items || [];
                                    
                                    // Pre-check unique masters for the icon-level click
                                    const uniqueMasters = [...new Set(lineItems
                                        .map(item => item.shipment?.master_tracking_number)
                                        .filter(tkn => tkn)
                                    )];

                                    // Set form data only if it's a multi-master scenario
                                    if (uniqueMasters.length > 1) {
                                        setNewOrderFormData(viewMoreActionsRow);
                                    }
                                }} 
                                fontSize="small"
                            />
                        </IconButton>
                    </Tooltip>

                    {/* 5. Connected Shipment Freight Tracker Map Drawer */}
                    <Tooltip title="View Shipments" placement="top">
                        <IconButton onClick={() => lineItemsDrawerOpen(viewMoreActionsRow)} style={{ color: '#1976d2' }}>
                            <LocalShippingOutlinedIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </Stack>
            </Popover>
            <Modal
                open={tagModalVisible}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: { xs: '90%', sm: 460, md: 500 },
                    maxHeight: '90vh',
                    overflowY: 'auto',
                    outline: 'none'
                }}>
                    <Card sx={{ borderRadius: '16px', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)', border: '1px solid #E2E8F0' }}>
                        <CardHeader 
                            title={<Typography variant="h6" sx={{ fontWeight: 800, color: '#1E293B' }}>Assign Tag</Typography>} 
                            action={
                                <Link to={{ pathname: "/settings/tag-settings" }} style={{ textDecoration: 'none' }}>
                                    <Button 
                                        variant="contained"
                                        sx={{
                                            textTransform: 'none',
                                            borderRadius: '8px',
                                            fontWeight: 700,
                                            fontSize: '13px',
                                            boxShadow: 'none',
                                            backgroundColor: '#1976d2', // --- UPDATED WITH EXACT HEX CODE MATCH ---
                                            color: '#FFFFFF',
                                            '&:hover': { backgroundColor: '#115293', boxShadow: 'none' }
                                        }}
                                    >
                                        Add New Tag
                                    </Button>
                                </Link>
                            }
                            sx={{ bgcolor: '#F8FAFC', p: 2.5, display: 'flex', alignItems: 'center' }}
                        />
                        <Divider sx={{ borderColor: '#E2E8F0' }} />
                        
                        <CardContent sx={{ p: 4 }}>
                            <Stack spacing={3.5}>
                                
                                <FormControl 
                                    fullWidth 
                                    variant="outlined" 
                                    sx={{
                                        width: '100%',
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '10px',
                                            backgroundColor: '#FFFFFF',
                                            transition: 'all 0.2s ease-in-out',
                                            border: '1px solid #E2E8F0',
                                            '& fieldset': { border: 'none' },
                                            '&:hover': { borderColor: '#CBD5E1' },
                                            '&.Mui-focused': {
                                                borderColor: '#1976d2', // --- UPDATED WITH EXACT HEX CODE MATCH ---
                                                boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.08)'
                                            }
                                        },
                                        '& .MuiInputLabel-outlined': {
                                            color: '#64748B',
                                            fontWeight: 500,
                                            transform: 'translate(14px, 12px) scale(1)',
                                            '&.Mui-focused, &.MuiInputLabel-shrink': {
                                                transform: 'translate(14px, -8px) scale(0.75)',
                                                color: '#1976d2', // --- UPDATED WITH EXACT HEX CODE MATCH ---
                                                fontWeight: 600
                                            }
                                        },
                                        '& .MuiSelect-select': {
                                            padding: '11px 14px',
                                            fontSize: '14px',
                                            color: '#1E293B',
                                            fontWeight: 500
                                        }
                                    }}
                                >
                                    <InputLabel id="assign-tag-dropdown-label">Choose tag</InputLabel>
                                    <Select
                                        labelId="assign-tag-dropdown-label"
                                        id="assign-tag-dropdown-selector"
                                        name="tag"
                                        value={assignTagValue}
                                        onChange={(e) => setAssignTagValue(e.target.value)}
                                        label="Choose tag"
                                    >
                                        {tags && tags.data && tags.data.map((item) => {
                                            return (
                                                <MenuItem key={item.tag_name} value={item.tag_name}>
                                                    <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#334155' }}>
                                                        {item.tag_name}
                                                    </Typography>
                                                </MenuItem>
                                            );
                                        })}
                                        <MenuItem value={""}>
                                            <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#94A3B8', fontStyle: 'italic' }}>
                                                None
                                            </Typography>
                                        </MenuItem>
                                    </Select>
                                </FormControl>

                                <Divider sx={{ borderColor: '#E2E8F0', borderStyle: 'dashed' }} />

                                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                                    <Button 
                                        variant="outlined" 
                                        onClick={() => { setTagModalVisible(false) }}
                                        sx={{
                                            textTransform: 'none',
                                            borderRadius: '10px',
                                            fontWeight: 700,
                                            px: 3.5,
                                            py: 1,
                                            borderColor: '#E2E8F0',
                                            color: '#475569',
                                            '&:hover': {
                                                borderColor: '#CBD5E1',
                                                backgroundColor: '#F1F5F9',
                                                color: '#1E293B'
                                            }
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button 
                                        variant="contained" 
                                        onClick={() => { updateAssignTagHandle(assignTagIds, assignTagValue) }}
                                        sx={{
                                            textTransform: 'none',
                                            borderRadius: '10px',
                                            fontWeight: 700,
                                            px: 5,
                                            py: 1,
                                            boxShadow: 'none',
                                            backgroundColor: '#1976d2', // --- UPDATED WITH EXACT HEX CODE MATCH ---
                                            color: '#FFFFFF',
                                            '&:hover': {
                                                backgroundColor: '#115293',
                                                boxShadow: 'none'
                                            }
                                        }}
                                    >
                                        Submit
                                    </Button>
                                </Box>

                            </Stack>
                        </CardContent>
                    </Card>
                </Box>
            </Modal>
            <Modal
                open={bulkDimensionModalVisible}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={tagstyle}>
                    <Card sx={{ minWidth: 600 }} className="sc--cardhead--details">
                        <CardHeader title='Bulk Dimension' 
                         action={
                            <div>
                                <Link to={{ pathname: "/settings/box" }}><Button variant="contained" >Add Box Dimension</Button></Link>
                            </div>
                        }/>
                        <Divider />
                        <CardContent>
                                <div className="sc--form--center" style={{ margin: '20px 0' }}>
                                    <Autocomplete
                                        className="help-text-error"
                                        disablePortal
                                        name="choosenmeasurement"
                                        id="state-select-demo"
                                        sx={{ width: "100%",margin:'8px'}}
                                        options={boxData}
                                        autoHighlight
                                        loading={
                                        (box && box.loading)
                                        }
                                        getOptionLabel={(option) => option.box_name=='custom' ? ""+option.box_name+"": ( ""+option.box_name+" ("+option.box_length+option.box_length_unit+"x "+ option.box_width+option.box_width_unit+"x "+ option.box_height+option.box_height_unit+", "+option.box_weight+option.box_weight_unit+")")}
                                        filterOptions={filterOptions}
                                        value={getChooseMeasurement(dimensionValue._id)}
                                        renderOption={(props, option) => (
                                        <MenuItem {...props} value={option._id} key={option._id}>
                                            {option.box_name =='custom' ?
                                            <p style={{ margin: 'unset', color: 'rgba(0, 0, 0, 0.87)' }}>
                                                {option.box_name}
                                            </p>:
                                            <p style={{ margin: 'unset', color: 'rgba(0, 0, 0, 0.87)' }}>
                                            {option.box_name}(
                                            {option.box_length}{option.box_length_unit} <span style={{ color: '#0082ff' }}> x </span>
                                                            {option.box_width}{option.box_width_unit} <span style={{ color: '#0082ff' }}> x </span>
                                                            {option.box_height}{option.box_height_unit}<span>, </span>
                                                            {option.box_weight}{option.box_weight_unit})
                                            </p>}
                                        </MenuItem>
                                        )}
                                        onChange={(event, value) => {
                                            if (value !== null) {
                                                let event={
                                                    "target":{
                                                        "name":"choosenmeasurement",
                                                        "value":value._id
                                                    }}
                                                onBoxDimensionChange(event);
                                            } 
                                        }}
                                        renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Choose Measurement"
                                            variant="standard"
                                        />
                                        )}
                                    />
                                </div>
                                <div className="sc--form--center" style={{ margin: '10px 0' }}>
                                    <TextField id="standard-basic"
                                        label="Length"
                                        variant="standard"
                                        name="box_length"
                                        type="number"
                                        inputProps={{ min: 1 }}
                                        value={dimensionValue.box_length}
                                        onChange={event => onBoxDimensionChange(event)}
                                        error={dimensionsErrors.box_length}
                                        helperText={dimensionsErrors.box_length}
                                        style={{ width: '17%' }}
                                    />
                                    <TextField id="standard-basic"
                                        label="Width"
                                        variant="standard"
                                        name="box_width"
                                        type="number"
                                        inputProps={{ min: 1 }}
                                        value={dimensionValue.box_width}
                                        onChange={event => onBoxDimensionChange(event)}
                                        error={dimensionsErrors.box_width}
                                        helperText={dimensionsErrors.box_width}
                                        style={{ width: '17%' }}
                                    />
                                    <TextField id="standard-basic"
                                        label="Height"
                                        variant="standard"
                                        name="box_height"
                                        type="number"
                                        inputProps={{ min: 1 }}
                                        value={dimensionValue.box_height}
                                        onChange={event => onBoxDimensionChange(event)}
                                        error={dimensionsErrors.box_height}
                                        helperText={dimensionsErrors.box_height}
                                        style={{ width: '17%' }}
                                    />
                                    <FormControl
                                        variant="standard"
                                        className="help-text-error"
                                        style={{ width: '29%', margin: '8px' }}
                                    >
                                        <InputLabel
                                            style={{ color: dimensionsErrors.box_dimension_unit ? "#D32F2F" : '' }}
                                        > Dim Unit
                                    </InputLabel>
                                        <Select
                                            name="box_dimension_unit"
                                            onChange={event => onBoxDimensionChange(event)}
                                            value={dimensionValue.box_dimension_unit}
                                            error={dimensionsErrors.box_dimension_unit}
                                            label="Dimension Unit"
                                            id="filled-error-helper-text"
                                        >
                                            <MenuItem value="in">in</MenuItem>
                                            <MenuItem value="cm">cm</MenuItem>
                                        </Select>
                                        <FormHelperText>{dimensionsErrors.box_dimension_unit}</FormHelperText>
                                    </FormControl>

                                </div>
                                <div className="sc--form--center" style={{ margin: '10px 0' }}>
                                    <TextField id="actual-weight-id"
                                        label="Actual weight"
                                        variant="standard"
                                        name="box_actual_weight"
                                        type="number"
                                        inputProps={{ min: 1 }}
                                        value={dimensionValue.box_actual_weight}
                                        autoFocus={true}
                                        onChange={event => onBoxDimensionChange(event)}
                                        error={dimensionsErrors.box_actual_weight}
                                        helperText={dimensionsErrors.box_actual_weight}
                                        style={{ width: '50%' }} />

                                    <FormControl
                                        variant="standard"
                                        className="help-text-error"
                                        style={{ width: '30%', margin: '8px' }}
                                    >
                                        <InputLabel
                                            id="demo-simple-select-standard-label"
                                            style={{ color: dimensionsErrors.box_weight_unit ? "#D32F2F" : '' }}
                                        > Weight Unit
                                    </InputLabel>
                                        <Select
                                            labelId="demo-simple-select-standard-label"
                                            name="box_weight_unit"
                                            onChange={event => onBoxDimensionChange(event)}
                                            value={dimensionValue.box_weight_unit}
                                            label="Weight Unit"
                                        >
                                            <MenuItem value="lb">lb</MenuItem>
                                            <MenuItem value="kg">kg</MenuItem>
                                            <MenuItem value="g">g</MenuItem>
                                        </Select>
                                        <FormHelperText>{dimensionsErrors.box_weight_unit}</FormHelperText>
                                    </FormControl>
                                </div>
                                <div className="sc--form--center" style={{ margin: '10px 0' }}>
                                    <TextField id="insurance-amount-id"
                                        label="Insurance Amount (Optional)"
                                        variant="standard"
                                        name="insurance_amount"
                                        type="number"
                                        inputProps={{ min: 1 }}
                                        value={dimensionValue.insurance_amount}
                                        autoFocus={true}
                                        onChange={event => onBoxDimensionChange(event)}
                                        style={{ width: '50%' }} />
                                </div>
                                <div className="sc--form--center" style={{ margin: '30px 0' }}>
                                    <Button variant="outlined" disabled={orders && orders.addBulkDimension && orders.addBulkDimension.loading === true ? true:false} style={{marginRight:'10px'}} onClick={() =>{addBulkDimensionsForm(bulkDimensionIds,dimensionValue)}}>Submit</Button>
                                    <Button variant="outlined" onClick={() => { 
                                        setBulkDimensionModalVisible(false)
                                        setDimensionValue(initialBoxValues)
                                        setDimensionsErrors({})
                                        }}>Cancel</Button>
                                </div>
                        </CardContent>
                    </Card>
                </Box>
            </Modal >
            <Modal
                open={modalVisible}
                aria-labelledby="bulk-modal-title"
                aria-describedby="bulk-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: { 
                        xs: '92%', 
                        sm: modalDetails === 'shipment' ? 680 : 460, 
                        md: modalDetails === 'shipment' ? 720 : 500 
                    },
                    maxHeight: '90vh',
                    overflowY: 'auto',
                    outline: 'none',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <Card sx={{ borderRadius: '16px', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                        
                        {/* Real-time Processing Feed Adornment */}
                        {bulkvalidationOrdersData && bulkvalidationOrdersData.loading === true && (
                            <LinearProgress sx={{ height: '4px', backgroundColor: '#E2E8F0', '& .MuiLinearProgress-bar': { backgroundColor: '#1976d2' } }} />
                        )}

                        {/* Modal Structural Header Block */}
                        <CardHeader 
                            title={
                                <Typography id="bulk-modal-title" variant="h6" sx={{ fontWeight: 800, color: '#1E293B', textAlign: 'center' }}>
                                    {modalDetailsCollection[modalDetails].title}
                                </Typography>
                            } 
                            sx={{ bgcolor: '#F8FAFC', p: 2.5 }}
                        />
                        <Divider sx={{ borderColor: '#E2E8F0' }} />
                        
                        <CardContent sx={{ p: 4, textAlign: 'center' }}>
                            <Stack spacing={3}>
                                
                                {/* Operational Description Hub Content */}
                                <Typography id="bulk-modal-description" variant="body2" sx={{ color: '#475569', lineHeight: 1.6, fontSize: '14px' }}>
                                    {modalDetailsCollection[modalDetails].description}
                                </Typography>

                                {/* Operational system Note Warning callouts */}
                                {typeof modalDetailsCollection[modalDetails].note !== "undefined" && (
                                    <Box sx={{ p: 2, bgcolor: '#FFFBEB', borderRadius: '10px', border: '1px solid #FEF3C7', textAlign: 'left' }}>
                                        <Typography variant="caption" sx={{ color: '#B45309', fontWeight: 700, display: 'block', mb: 0.5 }}>
                                            NOTE:
                                        </Typography>
                                        <Typography variant="caption" sx={{ color: '#78350F', fontWeight: 500, lineHeight: 1.5 }}>
                                            {modalDetailsCollection[modalDetails].note}
                                        </Typography>
                                    </Box>
                                )}

                                {/* Dynamic Error Table Mapping Hooks Injection Point */}
                                {modalDetails === 'shipment' && bulkvalidationOrdersData && bulkvalidationOrdersData.data && Object.keys(bulkvalidationOrdersData.data).length !== 0 && bulkvalidationOrdersData.data.invalid_order_docids && bulkvalidationOrdersData.data.invalid_order_docids.length > 0 && (
                                    <Box sx={{ mt: 1, textAlign: 'left', width: '100%' }}>
                                        {errorTable(bulkvalidationOrdersData.data.invalid_order_docids)}
                                    </Box>
                                )}

                                {/* Standard Administrative Delivery Notes Text Area Block */}
                                {modalDetails === 'shipment' && (
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        label="Notes"
                                        name="notes"
                                        inputProps={{ maxLength: 200 }}
                                        onInput={e => setNotes(e.target.value)}
                                        size="small"
                                        sx={{
                                            alignSelf: 'center',
                                            width: '90%',
                                            mt: 1,
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '10px',
                                                backgroundColor: '#FFFFFF',
                                                transition: 'all 0.2s ease-in-out',
                                                border: '1px solid #E2E8F0',
                                                '& fieldset': { border: 'none' },
                                                '&:hover': { borderColor: '#CBD5E1' },
                                                '&.Mui-focused': {
                                                    borderColor: '#1976d2',
                                                    boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.08)'
                                                }
                                            },
                                            '& .MuiInputLabel-outlined': {
                                                color: '#64748B',
                                                fontWeight: 500,
                                                transform: 'translate(14px, 10px) scale(1)',
                                                '&.Mui-focused, &.MuiInputLabel-shrink': {
                                                    transform: 'translate(14px, -8px) scale(0.75)',
                                                    color: '#1976d2',
                                                    fontWeight: 600
                                                }
                                            },
                                            '& input': {
                                                padding: '10px 14px',
                                                fontSize: '14px',
                                                color: '#1E293B'
                                            }
                                        }}
                                    />
                                )}

                                <Divider sx={{ my: 1, borderColor: '#E2E8F0', borderStyle: 'dashed' }} />

                                {/* Operational CTA Interaction controls */}
                                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 1 }}>
                                    <Button 
                                        variant="outlined" 
                                        onClick={() => setModalVisible(false)}
                                        sx={{
                                            textTransform: 'none',
                                            borderRadius: '10px',
                                            fontWeight: 700,
                                            px: 4,
                                            py: 1,
                                            minWidth: 110,
                                            borderColor: '#E2E8F0',
                                            color: '#475569',
                                            '&:hover': {
                                                borderColor: '#CBD5E1',
                                                backgroundColor: '#F1F5F9',
                                                color: '#1E293B'
                                            }
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button 
                                        variant="contained" 
                                        disabled={bulkvalidationOrdersData && bulkvalidationOrdersData.loading === true} 
                                        onClick={() => modalDetailsCollection[modalDetails].onOk()}
                                        sx={{
                                            textTransform: 'none',
                                            borderRadius: '10px',
                                            fontWeight: 700,
                                            px: 5,
                                            py: 1,
                                            minWidth: 110,
                                            boxShadow: 'none',
                                            backgroundColor: '#1976d2',
                                            color: '#FFFFFF',
                                            '&:hover': {
                                                backgroundColor: '#115293',
                                                boxShadow: 'none'
                                            },
                                            '&.Mui-disabled': {
                                                backgroundColor: '#E2E8F0',
                                                color: '#94A3B8'
                                            }
                                        }}
                                    >
                                        Ok
                                    </Button>
                                </Box>

                            </Stack>
                        </CardContent>
                    </Card>
                </Box>
            </Modal>
            <Modal open={cooModalVisible} onClose={() => setCooModalVisible(false)}>
                <Box sx={{ ...tagstyle, display: 'flex', alignItems: 'center', justifyContent: 'center', outline: 'none' }}>
                    <Card sx={{ width: 650, borderRadius: '12px', boxShadow: '0 12px 40px rgba(0,0,0,0.15)' }}>
                        <CardHeader 
                            title={<Typography variant="h6" sx={{ fontWeight: 800 }}>Bulk Line Item Update</Typography>}
                            sx={{ bgcolor: '#f8f9fa', borderBottom: '1px solid #eee' }}
                        />
                        <Divider />
                        <CardContent sx={{ p: 4 }}>
                            {/* Selected IDs Display - Enterprise Chip Style */}
                            <Box sx={{ mb: 3 }}>
                                <Typography variant="caption" sx={{ fontWeight: 700, color: '#666', mb: 1, display: 'block', textTransform: 'uppercase' }}>
                                    Selected Document IDs ({bulkCooOrderIds.length})
                                </Typography>
                                <Box sx={{ 
                                    maxHeight: '80px', overflowY: 'auto', p: 1.5, bgcolor: '#f4f6f8', 
                                    borderRadius: '8px', border: '1px solid #dfe3e8', display: 'flex', flexWrap: 'wrap', gap: 0.5 
                                }}>
                                    {bulkCooOrderIds.map((id) => (
                                        <Chip key={id} label={id} size="small" sx={{ bgcolor: '#fff', border: '1px solid #ced4da', fontWeight: 600 }} />
                                    ))}
                                </Box>
                            </Box>

                            <Grid container spacing={3}>
                                {/* Country of Origin Autocomplete */}
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="caption" sx={{ fontWeight: 700, mb: 0.5, display: 'block' }}>COUNTRY OF ORIGIN</Typography>
                                    <Autocomplete
                                        options={filteredCountryData}
                                        getOptionLabel={(option) => option.name}
                                        value={getSelectedCountry(coovalues.coo)}
                                        onChange={(e, val) => setCooValues({ ...coovalues, coo: val ? val.code : "" })}
                                        renderInput={(params) => (
                                            <TextField {...params} placeholder="Select Country" variant="outlined" size="small" />
                                        )}
                                    />
                                </Grid>

                                {/* HS Tariff Code Input */}
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="caption" sx={{ fontWeight: 700, mb: 0.5, display: 'block' }}>HS TARIFF CODE</Typography>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        placeholder="e.g. 6109.10.00.12"
                                        value={coovalues.hs_tariff_code}
                                        onChange={(e) => setCooValues({ ...coovalues, hs_tariff_code: e.target.value })}
                                        onBlur={handleHsBlur}
                                        error={!!cooerrors.hs_tariff_code}
                                        helperText={cooerrors.hs_tariff_code}
                                    />
                                </Grid>

                                {/* Update Scope Logic */}
                                <Grid item xs={12}>
                                    <Box sx={{ mt: 1, p: 2, bgcolor: '#fff9f0', borderRadius: '8px', border: '1px solid #ffecb3' }}>
                                        <Typography variant="caption" sx={{ fontWeight: 800, color: '#856404', display: 'block', mb: 1 }}>
                                            UPDATE SETTINGS
                                        </Typography>
                                        <RadioGroup
                                            value={coovalues.update}
                                            onChange={(e) => setCooValues({ ...coovalues, update: e.target.value })}
                                        >
                                            <FormControlLabel 
                                                value="All" 
                                                control={<Radio size="small" />} 
                                                label={<Typography variant="body2">Overwrite <b>ALL</b> eligible items</Typography>} 
                                            />
                                            <FormControlLabel 
                                                value="Not Exist" 
                                                control={<Radio size="small" />} 
                                                label={<Typography variant="body2">Only update items with <b>EMPTY</b> values</Typography>} 
                                            />
                                        </RadioGroup>
                                    </Box>
                                </Grid>
                            </Grid>

                            {/* Actions */}
                            <Box sx={{ mt: 4, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                                <Button 
                                    variant="text" 
                                    onClick={() => setCooModalVisible(false)}
                                    sx={{ color: '#637381', fontWeight: 700 }}
                                >
                                    Cancel
                                </Button>
                                <Button 
                                    variant="contained" 
                                    onClick={handleSubmit}
                                    disabled={!coovalues.coo && !coovalues.hs_tariff_code}
                                    sx={{ px: 4, borderRadius: '8px', fontWeight: 700, textTransform: 'none', boxShadow: 'none' }}
                                >
                                    Apply Bulk Changes
                                </Button>
                            </Box>
                        </CardContent>
                    </Card>
                </Box>
            </Modal>
            <Modal
                open={openSenderAddressModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: { xs: '90%', sm: 460, md: 500 },
                    maxHeight: '90vh',
                    overflowY: 'auto',
                    outline: 'none',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <Card 
                        sx={{ 
                            borderRadius: '16px', 
                            boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)', 
                            border: '1px solid #E2E8F0', 
                            overflow: 'hidden' 
                        }}
                    >
                        {/* Real-time Visual Notice Banner Callout Adornment */}
                        <Box sx={{ height: '4px', backgroundColor: '#F59E0B' }} />

                        <CardContent sx={{ p: 4, textAlign: 'center' }}>
                            <Stack spacing={2.5} alignItems="center">
                                
                                {/* Enterprise Warning Adornment Circle */}
                                <Box 
                                    sx={{ 
                                        width: '48px', 
                                        height: '48px', 
                                        borderRadius: '50%', 
                                        bgcolor: '#FEF3C7', 
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        justifyContent: 'center',
                                        color: '#D97706',
                                        mb: 0.5
                                    }}
                                >
                                    <svg width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                    </svg>
                                </Box>

                                {/* Modal Primary Title Header */}
                                <Typography 
                                    id="modal-modal-title" 
                                    variant="h6" 
                                    sx={{ 
                                        fontWeight: 800, 
                                        color: '#1E293B', 
                                        lineHeight: 1.4,
                                        px: 1
                                    }}
                                >
                                    Sender address not configured or default not set
                                </Typography>

                                {/* Modal Descriptive Explanatory Subtext */}
                                <Typography 
                                    id="modal-modal-description" 
                                    variant="body2" 
                                    sx={{ 
                                        color: '#64748B', 
                                        fontWeight: 500,
                                        lineHeight: 1.5,
                                        mt: 0
                                    }}
                                >
                                    Please configure sender address to create shipment
                                </Typography>

                                <Divider sx={{ width: '100%', borderColor: '#E2E8F0', borderStyle: 'dashed', my: 1 }} />

                                {/* Action Execution Footer Controls Frame */}
                                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                                    <Button 
                                        variant="contained" 
                                        onClick={() => { window.location = '/settings/address-sender'; }}
                                        sx={{
                                            textTransform: 'none',
                                            borderRadius: '10px',
                                            fontWeight: 700,
                                            px: 6,
                                            py: 1,
                                            minWidth: 140,
                                            boxShadow: 'none',
                                            backgroundColor: '#1976d2',
                                            color: '#FFFFFF',
                                            '&:hover': {
                                                backgroundColor: '#115293',
                                                boxShadow: 'none'
                                            }
                                        }}
                                    >
                                        Configure Address
                                    </Button>
                                </Box>

                            </Stack>
                        </CardContent>
                    </Card>
                </Box>
            </Modal>
            <Modal
                open={openBillingAddressModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: { xs: '90%', sm: 460, md: 500 },
                    maxHeight: '90vh',
                    overflowY: 'auto',
                    outline: 'none',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <Card 
                        sx={{ 
                            borderRadius: '16px', 
                            boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)', 
                            border: '1px solid #E2E8F0', 
                            overflow: 'hidden' 
                        }}
                    >
                        {/* Real-time Visual Notice Banner Callout Adornment */}
                        <Box sx={{ height: '4px', backgroundColor: '#F59E0B' }} />

                        <CardContent sx={{ p: 4, textAlign: 'center' }}>
                            <Stack spacing={2.5} alignItems="center">
                                
                                {/* Enterprise Warning Adornment Circle */}
                                <Box 
                                    sx={{ 
                                        width: '48px', 
                                        height: '48px', 
                                        borderRadius: '50%', 
                                        bgcolor: '#FEF3C7', 
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        justifyContent: 'center',
                                        color: '#D97706',
                                        mb: 0.5
                                    }}
                                >
                                    <svg width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                    </svg>
                                </Box>

                                {/* Modal Primary Title Header */}
                                <Typography 
                                    id="modal-modal-title" 
                                    variant="h6" 
                                    sx={{ 
                                        fontWeight: 800, 
                                        color: '#1E293B', 
                                        lineHeight: 1.4,
                                        px: 1
                                    }}
                                >
                                    Billing address not configured
                                </Typography>

                                {/* Modal Descriptive Explanatory Subtext */}
                                <Typography 
                                    id="modal-modal-description" 
                                    variant="body2" 
                                    sx={{ 
                                        color: '#64748B', 
                                        fontWeight: 500,
                                        lineHeight: 1.5,
                                        mt: 0
                                    }}
                                >
                                    Please configure billing address to create shipment
                                </Typography>

                                <Divider sx={{ width: '100%', borderColor: '#E2E8F0', borderStyle: 'dashed', my: 1 }} />

                                {/* Action Execution Footer Controls Frame */}
                                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                                    <Button 
                                        variant="contained" 
                                        onClick={() => { window.location = '/settings/address-billing'; }}
                                        sx={{
                                            textTransform: 'none',
                                            borderRadius: '10px',
                                            fontWeight: 700,
                                            px: 6,
                                            py: 1,
                                            minWidth: 140,
                                            boxShadow: 'none',
                                            backgroundColor: '#1976d2',
                                            color: '#FFFFFF',
                                            '&:hover': {
                                                backgroundColor: '#115293',
                                                boxShadow: 'none'
                                            }
                                        }}
                                    >
                                        Configure Address
                                    </Button>
                                </Box>

                            </Stack>
                        </CardContent>
                    </Card>
                </Box>
            </Modal>
            <Modal
                open={openBoxModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: { xs: '90%', sm: 460, md: 500 },
                    maxHeight: '90vh',
                    overflowY: 'auto',
                    outline: 'none',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <Card 
                        sx={{ 
                            borderRadius: '16px', 
                            boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)', 
                            border: '1px solid #E2E8F0', 
                            overflow: 'hidden' 
                        }}
                    >
                        {/* Real-time Visual Notice Banner Callout Adornment */}
                        <Box sx={{ height: '4px', backgroundColor: '#F59E0B' }} />

                        <CardContent sx={{ p: 4, textAlign: 'center' }}>
                            <Stack spacing={2.5} alignItems="center">
                                
                                {/* Enterprise Warning Adornment Circle */}
                                <Box 
                                    sx={{ 
                                        width: '48px', 
                                        height: '48px', 
                                        borderRadius: '50%', 
                                        bgcolor: '#FEF3C7', 
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        justifyContent: 'center',
                                        color: '#D97706',
                                        mb: 0.5
                                    }}
                                >
                                    <svg width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                                    </svg>
                                </Box>

                                {/* Modal Primary Title Header */}
                                <Typography 
                                    id="modal-modal-title" 
                                    variant="h6" 
                                    sx={{ 
                                        fontWeight: 800, 
                                        color: '#1E293B', 
                                        lineHeight: 1.4,
                                        px: 1
                                    }}
                                >
                                    Box settings not configured
                                </Typography>

                                {/* Modal Descriptive Explanatory Subtext */}
                                <Typography 
                                    id="modal-modal-description" 
                                    variant="body2" 
                                    sx={{ 
                                        color: '#64748B', 
                                        fontWeight: 500,
                                        lineHeight: 1.5,
                                        mt: 0
                                    }}
                                >
                                    Please configure Box settings to create shipment
                                </Typography>

                                <Divider sx={{ width: '100%', borderColor: '#E2E8F0', borderStyle: 'dashed', my: 1 }} />

                                {/* Action Execution Footer Controls Frame */}
                                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                                    <Button 
                                        variant="contained" 
                                        onClick={() => { window.location = '/settings/box'; }}
                                        sx={{
                                            textTransform: 'none',
                                            borderRadius: '10px',
                                            fontWeight: 700,
                                            px: 6,
                                            py: 1,
                                            minWidth: 140,
                                            boxShadow: 'none',
                                            backgroundColor: '#1976d2',
                                            color: '#FFFFFF',
                                            '&:hover': {
                                                backgroundColor: '#115293',
                                                boxShadow: 'none'
                                            }
                                        }}
                                    >
                                        Configure Boxes
                                    </Button>
                                </Box>

                            </Stack>
                        </CardContent>
                    </Card>
                </Box>
            </Modal>
            <Modal
                open={deleteOrdersModalVisible}
                aria-labelledby="void-confirm-modal-title"
                aria-describedby="void-confirm-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: { 
                        xs: '92%', 
                        sm: notDeleteOrders && notDeleteOrders.length > 0 ? 680 : 460, 
                        md: notDeleteOrders && notDeleteOrders.length > 0 ? 720 : 500 
                    },
                    maxHeight: '90vh',
                    overflowY: 'auto',
                    outline: 'none',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <Card sx={{ borderRadius: '16px', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)', border: '1px solid #E2E8F0', overflow: 'hidden' }}>
                        
                        {/* Real-time Data Mutation Processing Feed */}
                        {orders && orders.deleteOrders && orders.deleteOrders.loading === true && (
                            <LinearProgress sx={{ height: '4px', backgroundColor: '#E2E8F0', '& .MuiLinearProgress-bar': { backgroundColor: '#1976d2' } }} />
                        )}

                        {/* Dynamic Modal Header contextual tracking */}
                        <CardHeader 
                            title={
                                <Typography variant="h6" sx={{ fontWeight: 800, color: '#1E293B', textAlign: 'center' }}>
                                    {notDeleteOrders && notDeleteOrders.length > 0 ? "Deletion Restriction Log" : "Remove Orders Confirmation"}
                                </Typography>
                            } 
                            sx={{ bgcolor: '#F8FAFC', p: 2.5 }}
                        />
                        <Divider sx={{ borderColor: '#E2E8F0' }} />
                        
                        <CardContent sx={{ p: 4 }}>
                            <Stack spacing={3}>
                                
                                {/* --- CONDITION A: RESTRICTED MANIFEST DATA VIEW --- */}
                                {notDeleteOrders && notDeleteOrders.length > 0 && (
                                    <Box sx={{ width: '100%' }}>
                                        <Box sx={{ mb: 1.5, p: 2, bgcolor: '#FEF2F2', border: '1px solid #FEE2E2', borderRadius: '10px' }}>
                                            <Typography variant="body2" sx={{ color: '#991B1B', fontWeight: 600, textAlign: 'center' }}>
                                                The following orders cannot be processed for permanent removal under active pipeline specifications:
                                            </Typography>
                                        </Box>
                                        
                                        {notDeleteOrdersTable(notDeleteOrders)}
                                        
                                        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                                            <Button 
                                                variant="outlined" 
                                                onClick={() => { 
                                                    setDeleteOrdersModalVisible(false);
                                                    setNotDeletedOrders([]);
                                                }}
                                                sx={{
                                                    textTransform: 'none',
                                                    borderRadius: '10px',
                                                    fontWeight: 700,
                                                    px: 5,
                                                    py: 1,
                                                    borderColor: '#E2E8F0',
                                                    color: '#475569',
                                                    '&:hover': { borderColor: '#CBD5E1', backgroundColor: '#F1F5F9' }
                                                }}
                                            >
                                                Cancel
                                            </Button>
                                        </Box>
                                    </Box>
                                )}

                                {/* --- CONDITION B: STANDALONE DELETION DESTRUCTIVE EXECUTION VIEW --- */}
                                {notDeleteOrders && notDeleteOrders.length === 0 && (
                                    <Box sx={{ textAlign: 'center' }}>
                                        {/* Danger Alert Icon Adornment */}
                                        <Box 
                                            sx={{ 
                                                width: '56px', 
                                                height: '56px', 
                                                borderRadius: '50%', 
                                                bgcolor: '#FEF2F2', 
                                                display: 'flex', 
                                                alignItems: 'center', 
                                                justifyContent: 'center',
                                                color: '#EF4444',
                                                mx: 'auto',
                                                mb: 2.5
                                            }}
                                        >
                                            <svg width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-4v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                            </svg>
                                        </Box>

                                        <Typography 
                                            id="void-confirm-modal-description" 
                                            variant="h6" 
                                            sx={{ fontWeight: 700, color: '#1E293B', px: 2, fontSize: '17px', mb: 1 }}
                                        >
                                            Are you sure?
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: '#64748B', mb: 3.5 }}>
                                            Do you want to remove all these selected orders? This action cannot be undone.
                                        </Typography>

                                        <Divider sx={{ borderStyle: 'dashed', borderColor: '#E2E8F0', mb: 3 }} />

                                        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
                                            <Button 
                                                variant="outlined" 
                                                onClick={() => { setDeleteOrdersModalVisible(false); }}
                                                sx={{
                                                    textTransform: 'none',
                                                    borderRadius: '10px',
                                                    fontWeight: 700,
                                                    px: 4,
                                                    py: 1,
                                                    minWidth: 110,
                                                    borderColor: '#E2E8F0',
                                                    color: '#475569',
                                                    '&:hover': { borderColor: '#CBD5E1', backgroundColor: '#F1F5F9' }
                                                }}
                                            >
                                                No
                                            </Button>
                                            <LoadingButton  
                                                variant="contained" 
                                                loading={orders && orders.deleteOrders && orders.deleteOrders.loading === true} 
                                                onClick={() => { deleteOrdersValues(); }}
                                                sx={{
                                                    textTransform: 'none',
                                                    borderRadius: '10px',
                                                    fontWeight: 700,
                                                    px: 4,
                                                    py: 1,
                                                    minWidth: 110,
                                                    boxShadow: 'none',
                                                    backgroundColor: '#1976d2', // --- CORPORATE IDENTITY BRAND MATRIX MATCH ---
                                                    color: '#FFFFFF',
                                                    '&:hover': { backgroundColor: '#115293', boxShadow: 'none' },
                                                    '&.Mui-disabled': { backgroundColor: '#E2E8F0', color: '#94A3B8' }
                                                }}
                                            >
                                                Yes
                                            </LoadingButton>
                                        </Box>
                                    </Box>
                                )}

                            </Stack>
                        </CardContent>
                    </Card>
                </Box>
            </Modal>
            <div className="scmaincard">
                {/* ─── DYNAMIC UNFULFILLED SYNC ALERT (AUTO-CLOSES IN 5 SECONDS) ─── */}
                <Collapse in={unfulfilledSyncAlert.show}>
                    <Alert 
                        severity={unfulfilledSyncAlert.type} 
                        onClose={() => setUnfulfilledSyncAlert(prev => ({ ...prev, show: false }))}
                        sx={{ mb: 2, borderRadius: '10px', fontWeight: 600 }}
                    >
                        {unfulfilledSyncAlert.message}
                    </Alert>
                </Collapse>
               <Box 
                    className="sccardhead"
                    sx={{ 
                        display: 'flex', 
                        flexDirection: { xs: 'column', md: 'row' }, 
                        alignItems: { xs: 'stretch', md: 'center' }, 
                        justifyContent: 'space-between',
                        gap: 2, 
                        mb: 3.5,
                        width: '100%'
                    }}
                >
                    {/* Page Title */}
                    <Typography 
                        variant="h5" 
                        component="div" 
                        sx={{ 
                            fontWeight: 800, 
                            color: '#1E293B',
                            m: 0 
                        }}
                    >
                        Orders
                    </Typography>

                    {/* Enterprise Operational Features Toolbar */}
                    <Stack 
                        component="ul" 
                        className="features-list"
                        direction="row" 
                        alignItems="center" 
                        flexWrap="wrap"
                        sx={{ 
                            listStyle: 'none', 
                            p: 0, 
                            m: 0,
                            justifyContent: { xs: 'flex-start', md: 'flex-end' }
                        }}
                    >

                        {/* 2. Save Active Columns DataGrid Configuration Profile View */}
                        {datagridSave === false && (
                            <Box component="li">
                                <Tooltip title="Save this column size and ordering" placement="top">
                                    <LoadingButton 
                                        variant="outlined" 
                                        disabled={datagridSave} 
                                        loading={orderUIUpdate && orderUIUpdate.loading} 
                                        onClick={() => onDatagridSave()}
                                        sx={{
                                            textTransform: 'none',
                                            borderRadius: '10px',
                                            fontWeight: 700,
                                            px: 2.5,
                                            borderColor: '#E2E8F0',
                                            color: '#1976d2', // Updated to match corporate theme
                                            '&:hover': {
                                                borderColor: '#1976d2',
                                                backgroundColor: 'rgba(25, 118, 210, 0.04)'
                                            }
                                        }}
                                    >
                                        Save this view
                                    </LoadingButton>
                                </Tooltip>
                            </Box>
                        )}

                        {/* 3. Conditional Shipment Context Generation Action Triggers */}
                        {urlParam === "returnorders" ? (
                            <Box component="li">
                                <Tooltip title="Create Return order" placement="top">
                                    <Button
                                        variant="contained"
                                        disabled={profile && profile.disable_create_shipment === true}
                                        onClick={() => returnOrderCreateCallback("", true, "")}
                                        startIcon={<KeyboardReturnOutlinedIcon />}
                                        sx={{
                                            textTransform: 'none',
                                            borderRadius: '10px',
                                            fontWeight: 700,
                                            px: 3,
                                            boxShadow: 'none',
                                            backgroundColor: '#1976d2', // --- CHANGED TO CORPORATE BLUE ACCENT ---
                                            color: '#FFFFFF',
                                            '&:hover': { backgroundColor: '#115293', boxShadow: 'none' },
                                            '&.Mui-disabled': { backgroundColor: '#E2E8F0', color: '#94A3B8' }
                                        }}
                                    >
                                        Return Order
                                    </Button>
                                </Tooltip>
                            </Box>
                        ) : (
                            <Box component="li">
                                <Tooltip title="Create Order" placement="top">
                                    <Button
                                        variant="contained"
                                        disabled={profile && profile.disable_create_shipment === true}
                                        onClick={() => newOrderCreateCallback("")}
                                        startIcon={<AddCircleOutlineRoundedIcon />}
                                        sx={{
                                            textTransform: 'none',
                                            borderRadius: '10px',
                                            fontWeight: 700,
                                            px: 3,
                                            boxShadow: 'none',
                                            backgroundColor: '#1976d2', // --- CHANGED TO CORPORATE BLUE ACCENT ---
                                            color: '#FFFFFF',
                                            '&:hover': { backgroundColor: '#115293', boxShadow: 'none' },
                                            '&.Mui-disabled': { backgroundColor: '#E2E8F0', color: '#94A3B8' }
                                        }}
                                    >
                                        Order
                                    </Button>
                                </Tooltip>
                            </Box>
                        )}

                        {/* ─── NEW SHIPMENT BULK ACTION ─── */}
                        <Box component="li">
                            <Tooltip 
                                title={profile && profile.disable_create_shipment === true ? "Shipment creation disabled" : !(checkedIds && checkedIds.length >= 1) ? "Select items to initialize shipment" : "Create Shipment"} 
                                placement="top"
                            >
                                <span> {/* Wrap in an unstyled span tag to allow Tooltip visibility when Button is disabled */}
                                    <Button 
                                        disabled={!!((orders && orders.createShipmentBulk && orders.createShipmentBulk.loading === true) || (profile && profile.disable_create_shipment === true) || !(checkedIds && checkedIds.length >= 1))} 
                                        onClick={() => {
                                            groupAction("creatshipment");
                                            createShipmentOrderValidate();
                                            setActionAnchorEl(null);
                                        }}
                                        variant="outlined"
                                        size="small"
                                        startIcon={<AddCircleOutlineRoundedIcon fontSize="small" />}
                                        sx={{ 
                                            textTransform: 'none',
                                            borderRadius: '10px', 
                                            border: '1px solid #E2E8F0',
                                            bgcolor: '#FFFFFF',
                                            color: '#1976d2', 
                                            fontWeight: 600,
                                            fontSize: '13px',
                                            height: '36px',
                                            px: 2,
                                            transition: 'all 0.15s ease-in-out',
                                            '&:hover': { bgcolor: 'rgba(25, 118, 210, 0.04)', borderColor: '#CBD5E1' },
                                            '&.Mui-disabled': { bgcolor: '#F8FAFC', borderColor: '#F1F5F9', color: '#94A3B8' }
                                        }}
                                    >
                                        Label
                                    </Button>
                                </span>
                            </Tooltip>
                        </Box>

                        {/* ─── VOID SHIPMENT ACTION ─── */}
                        <Box component="li">
                            <Tooltip title={!(checkedIds && checkedIds.length >= 1) ? "Select items to void" : "Void Shipment"} placement="top">
                                <span>
                                    <Button 
                                        disabled={!!((orders && orders.voidShipment && orders.voidShipment.loading === true) || !(checkedIds && checkedIds.length >= 1))} 
                                        onClick={() => {
                                            groupAction("voidshipment");
                                            bulkVoidOrderValidate();
                                        }}
                                        variant="outlined"
                                        size="small"
                                        startIcon={<DeleteOutlineOutlinedIcon fontSize="small" />}
                                        sx={{ 
                                            textTransform: 'none',
                                            borderRadius: '10px', 
                                            border: '1px solid #FEE2E2', // Soft emergency danger styles
                                            bgcolor: '#FFFFFF',
                                            color: '#EF4444', 
                                            fontWeight: 600,
                                            fontSize: '13px',
                                            height: '36px',
                                            px: 2,
                                            transition: 'all 0.15s ease-in-out',
                                            '&:hover': { bgcolor: '#FEF2F2', borderColor: '#FCA5A5' },
                                            '&.Mui-disabled': { bgcolor: '#F8FAFC', borderColor: '#F1F5F9', color: '#94A3B8' }
                                        }}
                                    >
                                        Void
                                    </Button>
                                </span>
                            </Tooltip>
                        </Box>

                        {/* ─── PRINT LABEL ACTION ─── */}
                        <Box component="li">
                            <Tooltip 
                                title={selectItemView == true && totalOrders > 100 ? "Bulk ceiling capacity exceeded (Max 100)" : !(checkedIds && checkedIds.length >= 1) ? "Select items to print labels" : "Print Label"} 
                                placement="top"
                            >
                                <span>
                                    <Button 
                                        disabled={!!((selectItemView == true && totalOrders > 100) || !(checkedIds && checkedIds.length >= 1))} 
                                        onClick={() => groupAction("printlabel")}
                                        variant="outlined"
                                        size="small"
                                        startIcon={<LocalPrintshopIcon fontSize="small" />}
                                        sx={{ 
                                            textTransform: 'none',
                                            borderRadius: '10px', 
                                            border: '1px solid #E2E8F0',
                                            bgcolor: '#FFFFFF',
                                            color: '#1976d2',
                                            fontWeight: 600,
                                            fontSize: '13px',
                                            height: '36px',
                                            px: 2,
                                            transition: 'all 0.15s ease-in-out',
                                            '&:hover': { bgcolor: 'rgba(25, 118, 210, 0.04)', borderColor: '#CBD5E1' },
                                            '&.Mui-disabled': { bgcolor: '#F8FAFC', borderColor: '#F1F5F9', color: '#94A3B8' }
                                        }}
                                    >
                                        Print
                                    </Button>
                                </span>
                            </Tooltip>
                        </Box>
                         {/* 4. Filter Component Panel Search Toggler */}
                        <Box component="li">
                            <Tooltip title="Search" placement="top">
                                <IconButton 
                                    onClick={() => onMenuClick("search", !showSearch)}
                                    sx={{ 
                                        borderRadius: '10px', 
                                        border: '1px solid #E2E8F0',
                                        bgcolor: showSearch ? 'rgba(25, 118, 210, 0.08)' : '#FFFFFF',
                                        color: '#1976d2', // Updated to corporate blueprint theme
                                        p: 1.2,
                                        '&:hover': { bgcolor: 'rgba(25, 118, 210, 0.04)', borderColor: '#CBD5E1' }
                                    }}
                                >
                                    <SearchIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </Box>

                        {/* 5. Custom Target Selection Settings Hub Trigger */}
                        <Box component="li">
                            <Tooltip title="Action" placement="top">
                                <IconButton  
                                    onClick={handleActionsClick}  
                                    sx={{ 
                                        borderRadius: '10px', 
                                        border: '1px solid #E2E8F0',
                                        bgcolor: actionOpen ? 'rgba(25, 118, 210, 0.08)' : '#FFFFFF',
                                        color: '#1976d2',
                                        p: 1.2,
                                        transition: 'all 0.2s',
                                        '&:hover': { bgcolor: 'rgba(25, 118, 210, 0.04)', borderColor: '#CBD5E1' }
                                    }}
                                >
                                    <SettingsIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </Box>

                        {/* 6. Filter Context Accordion Selector Toggle Trigger */}
                        <Box component="li">
                            <Tooltip title="Filter" placement="top">
                                <IconButton 
                                    onClick={() => onMenuClick("filter", !showFilter)}
                                    sx={{ 
                                        borderRadius: '10px', 
                                        border: '1px solid #E2E8F0',
                                        bgcolor: showFilter ? 'rgba(25, 118, 210, 0.08)' : '#FFFFFF',
                                        color: '#1976d2', // Updated to corporate blueprint theme
                                        p: 1.2,
                                        '&:hover': { bgcolor: 'rgba(25, 118, 210, 0.04)', borderColor: '#CBD5E1' }
                                    }}
                                >
                                    <FilterAltOutlinedIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </Box>

                        {/* 7. Export Manifest Metrics Data Sheet Pipeline Button */}
                        <Box component="li">
                            <Tooltip title="Latest 5000 orders will be exported" placement="top">
                                <IconButton 
                                    onClick={() => onExportClick()}
                                    sx={{ 
                                        borderRadius: '10px', 
                                        border: '1px solid #E2E8F0',
                                        bgcolor: '#FFFFFF',
                                        color: '#1976d2', // Updated to corporate blueprint theme
                                        p: 1.2,
                                        '&:hover': { bgcolor: 'rgba(25, 118, 210, 0.04)', borderColor: '#CBD5E1' }
                                    }}
                                >
                                    <FileDownloadIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </Box>

                        {/* 8. Show Dynamic Table Grid Workspace Column Select Dropdown Menu */}
                        <Box component="li">
                            <Tooltip title="Columns" placement="top">
                                <IconButton
                                    id="dynamic-column-positioned-button"
                                    aria-controls={showDynamicColumn ? "dynamic-column-positioned-menu" : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={showDynamicColumn ? 'true' : undefined}
                                    onClick={handleColumnsClick}
                                    sx={{ 
                                        borderRadius: '10px', 
                                        border: '1px solid #E2E8F0',
                                        bgcolor: showDynamicColumn ? 'rgba(25, 118, 210, 0.08)' : '#FFFFFF',
                                        color: '#1976d2', // Updated to corporate blueprint theme
                                        p: 1.2,
                                        '&:hover': { bgcolor: 'rgba(25, 118, 210, 0.04)', borderColor: '#CBD5E1' }
                                    }}
                                >
                                    <ViewColumnSharpIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    </Stack>
                </Box>

                <div>
                    {anchorEl != null && <DynamicColumns
                        visible={showDynamicColumn}
                        anchorEl={anchorEl}
                        columns={orders && orders.ordersColumns && orders.ordersColumns.columns}
                        columnCheckedObject={columnCheckedObject}
                        setColumnCheckedObject={setColumnCheckedObject}
                        updateDynamicColumns={updateDynamicColumns}
                        handleColumnsClose={handleColumnsClose}
                        loading={orders && orders.ordersColumns && orders.ordersColumns.loading}
                    />}
                    <Search visible={showSearch} meta={meta} setMeta={setMeta} />
                    <Filters visible={showFilter} meta={meta} setMeta={setMeta} carriers={orders && orders.carriers} tags={orders && orders.platformTags} orderTags={tags && tags} report={urlParam} />
                </div>
                {/* 1. Page Selection Banner Feed */}
                {selectItemTextVisible && selectItemView === false && (
                    <Box 
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            bgcolor: '#EFF6FF',
                            border: '1px solid #DBEAFE',
                            borderRadius: '10px',
                            py: 1.2,
                            px: 2,
                            mb: 2.5,
                            width: '100%',
                            boxShadow: '0 1px 2px 0 rgba(0,0,0,0.02)'
                        }}
                    >
                        <Typography 
                            variant="body2" 
                            sx={{ 
                                color: '#1E40AF', 
                                fontWeight: 600,
                                fontSize: '13.5px',
                                display: 'flex',
                                alignItems: 'center',
                                flexWrap: 'wrap',
                                gap: 0.5
                            }}
                        >
                            All <strong>{totalSelectedItems}</strong> orders on this page are selected.
                            <Box
                                component="span"
                                className="order-selected-text"
                                onClick={handleBulkSelectedOrders}
                                sx={{
                                    color: '#1976d2',
                                    fontWeight: 700,
                                    cursor: 'pointer',
                                    ml: 1,
                                    textDecoration: 'underline',
                                    transition: 'color 0.15s ease-in-out',
                                    '&:hover': {
                                        color: '#115293'
                                    }
                                }}
                            >
                                Select {totalOrders <= 2500 ? totalOrders : 2500} Orders
                            </Box>
                        </Typography>
                    </Box>
                )}

                {/* 2. Global Manifest Selection Banner Feed */}
                {selectItemView && (
                    <Box 
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            bgcolor: '#F0FDF4',
                            border: '1px solid #DCFCE7',
                            borderRadius: '10px',
                            py: 1.2,
                            px: 2,
                            mb: 2.5,
                            width: '100%',
                            boxShadow: '0 1px 2px 0 rgba(0,0,0,0.02)'
                        }}
                    >
                        <Typography 
                            variant="body2" 
                            sx={{ 
                                color: '#166534', 
                                fontWeight: 600,
                                fontSize: '13.5px',
                                display: 'flex',
                                alignItems: 'center',
                                flexWrap: 'wrap',
                                gap: 0.5
                            }}
                        >
                            <strong>
                                {orders && orders.ordersData && orders.ordersData.meta && orders.ordersData.meta.total && orders.ordersData.meta.total <= 2500 
                                    ? orders.ordersData.meta.total 
                                    : 2500
                                }
                            </strong> 
                            orders are selected.
                            <Box
                                component="span"
                                className="order-selected-text"
                                onClick={handleClearOrders}
                                sx={{
                                    color: '#DC2626',
                                    fontWeight: 700,
                                    cursor: 'pointer',
                                    ml: 1,
                                    textDecoration: 'underline',
                                    transition: 'color 0.15s ease-in-out',
                                    '&:hover': {
                                        color: '#991B1B'
                                    }
                                }}
                            >
                                Clear selection
                            </Box>
                        </Typography>
                    </Box>
                )}
                </div>
                <Box 
                    sx={{ 
                        backgroundColor: '#FFFFFF', 
                        width: '100%',
                        borderRadius: '16px',
                        border: '1px solid #E2E8F0',
                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.02)',
                        overflow: 'hidden'
                    }}
                >
                    {/* <DataGrid */}
                    <DataGridPro 
                        sx={{
                            border: 'none', // Border is now cleanly handled by the parent outer box layout wrapper
                            backgroundColor: '#FFFFFF',
                            overflow: 'hidden',
                            
                            // Fixes potential layout double borders or header alignment artifacts
                            '& .MuiDataGrid-topContainer': {
                                backgroundColor: '#F8FAFC',
                                '&::after': { display: 'none' }
                            },
                            
                            // Customizing Enterprise Header Styling
                            '& .MuiDataGrid-columnHeaders': {
                                backgroundColor: '#F8FAFC',
                                borderBottom: '1px solid #E2E8F0',
                                minHeight: '52px !important',
                                maxHeight: '52px !important'
                            },
                            '& .MuiDataGrid-columnHeader': {
                                color: '#475569',
                                fontWeight: 700,
                                fontSize: '13px',
                                textTransform: 'none',
                                letterSpacing: '0.1px',
                                '&:focus, &:focus-within': {
                                    outline: 'none'
                                }
                            },
                            
                            // Customizing Rows and Cells Layout Bounds
                            '& .MuiDataGrid-row': {
                                transition: 'background-color 0.15s ease-in-out',
                                borderBottom: '1px solid #F1F5F9',
                                alignItems: 'center',
                                '&:hover': {
                                    backgroundColor: '#F8FAFC'
                                },
                                '&.Mui-selected': {
                                    backgroundColor: 'rgba(25, 118, 210, 0.04)', // Soft micro-tint on selection
                                    '&:hover': {
                                        backgroundColor: 'rgba(25, 118, 210, 0.08)'
                                    }
                                }
                            },
                            '& .MuiDataGrid-cell': {
                                fontSize: '13.5px',
                                color: '#334155',
                                borderBottom: 'none',
                                display: 'flex',
                                alignItems: 'center',
                                py: '12px', // Enterprise spacing padding layout parameters
                                '&:focus, &:focus-within': {
                                    outline: 'none'
                                }
                            },

                            // Global Selection Checkbox Interaction Theming
                            '& .MuiCheckbox-root': {
                                color: '#CBD5E1',
                                '&.Mui-checked': {
                                    color: '#1976d2' // --- BRAND MATRIX SYSTEM ACCENT SYNC ---
                                }
                            },

                            // Toolbar Sub-Container Flex Layout Integration Alignment
                            '& .MuiDataGrid-toolbarContainer': {
                                borderBottom: '1px solid #E2E8F0',
                                padding: '12px 16px',
                                backgroundColor: '#F8FAFC',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                width: '100%',
                                boxSizing: 'border-box'
                            },

                            // Custom Linear Progress bar tracking layout styling overrides
                            '& .MuiLinearProgress-root': {
                                height: '3px',
                                backgroundColor: '#E2E8F0',
                                '& .MuiLinearProgress-bar': {
                                    backgroundColor: '#1976d2'
                                }
                            }
                        }}
                        getRowId={(row) => row._id}
                        rows={orders?.ordersData?.data || []}
                        columns={columns}
                        autoHeight
                        checkboxSelection
                        disableColumnFilter
                        disableColumnMenu
                        sortingMode="server"
                        rowGroupingColumn={null} // Disable automatic grouping
                        disableRowGrouping={true}
                        onRowSelectionModelChange={(newSelectionModel) =>
                            onSelectionChange(newSelectionModel, orders.ordersData.data)
                        }
                        columnVisibilityModel={{
                            rate: profile && profile.hide_rate ===true ? false : true,
                            duty_charges: profile && profile.hide_rate ===true ? false : true
                        }}
                        rowSelectionModel={checkedIds}
                        onSortModelChange={(newSortModel) => onSortChange(newSortModel)}
                        sortModel={meta?.sorting ? JSON.parse(meta.sorting) : []}
                        onColumnResize={onColumnResizeCustom}       
                        onColumnOrderChange={onColumnReorderingCustom}
                        disableRowSelectionOnClick
                        slots={{
                            footer: CustomPagination,
                            loadingOverlay: LinearProgress,
                            toolbar: CustomToolbar,
                            NorowsData // ✅ corrected key
                        }}
                        loading={
                            orders?.ordersData?.loading ||
                            orders?.createShipment?.loading ||
                            orders?.createShipmentBulk?.loading ||
                            orders?.voidShipment?.loading ||
                            orders?.manifestClose?.loading ||
                            orders?.bulkLabel?.loading ||
                            orders?.bulkSelectedOrdersData?.loading ||
                            orders?.deleteOrders?.loading ||
                            cooUpdate?.loading || orders?.orderShipmentDetails?.loading
                            || orders?.orderShipmentLabel?.loading
                        }
                        />
                </Box>
            <TrackingDrawer
                visible={trackingDrawerVisible}
                message={trackingMessage}
                isMultiPiece={isMultiPiece}
                onClose={onClose}
            />
            <OrderDrawer
                visible={orderDrawerVisible} 
                onClose={orderOnClose}
                isReturnOrder={isReturnOrder}
                setIsReturnOrder={setIsReturnOrder}
                orderRow={orderRow}
                meta={meta}
                orderId={orderId}
                invalidDocIds={invalidDocIds} 
            />
            {lineItemsDrawerVisible &&
            <LineItemsDrawer
                visible={lineItemsDrawerVisible}
                order={lineItemsData}
                onClose={lineItemsDrawerClose}
                isReturnOrder={isReturnOrder}
                setIsReturnOrder={setIsReturnOrder}
            />
            }
            <NewOrderCreateDrawer
                visible={newOrderCreateDrawerVisible}
                reportName={"ORDERS"}
                newOrderFormData={newOrderFormData}
                setNewOrderFormData={setNewOrderFormData}
                meta={meta}
                onClose={newOrderCreateOnClose}
                isDuplicateOrder={isDuplicateOrder}
                isReturnOrder={isReturnOrder}
                setIsReturnOrder={setIsReturnOrder}
                setNewOrderCreateDrawerVisible={setNewOrderCreateDrawerVisible}
                choosenTrackingNumber={choosenTrackingNumber}
                isShipmentCreationFlow={isShipmentCreationFlow}
            />
            <Popover
                open={Boolean(breakdownAnchorEl)}
                anchorEl={breakdownAnchorEl}
                onClose={handleDutiesClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                PaperProps={{
                    sx: { p: 2, bgcolor: '#212b36', color: '#fff', borderRadius: '8px', minWidth: '180px', boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }
                }}
            >
                {isLoadingDuties ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', py: 1 }}>
                        <CircularProgress size={20} sx={{ color: '#fff' }} />
                    </Box>
                ) : (
                    // Reuses the safe text rendering parser we built earlier!
                    selectedBreakdown && (
                        typeof selectedBreakdown.error === "string" || typeof selectedBreakdown.message === "string" ? (
                            <Typography variant="caption" sx={{ fontSize: '11px' }}>
                                {selectedBreakdown.error || selectedBreakdown.message}
                            </Typography>
                        ) : (
                            renderDutyTooltip(selectedBreakdown)
                        )
                    )
                )}
            </Popover>
        </>
    )

}

export default OrdersPage;